import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
} from "@angular/core";
import { interval, Observable, of } from "rxjs";
import { UserService } from "../../services/user.service";
import { Router, ActivatedRoute } from "@angular/router";
import { PipeTransform } from "@angular/core";
import moment from "moment-timezone";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { LoaderModalService } from "../../services/loader.service";
import { CartlengthService } from "../../services/cartlength.service";
import { DataLayerServiceService } from "src/app/data-layer-service.service";
import { CommonService } from "src/app/services/common.service";
import { BehaviorService } from "src/app/services/behaviour.service";
import { AppInjector } from "src/app/app.module";
import { ChatService } from "src/app/services/chat.service";
import Swal from "sweetalert2";
import { AppStateService } from "src/app/shared/app-state.service";

declare var $: any;

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.css"],
})
export class SidenavComponent implements OnInit, AfterViewInit, PipeTransform {
  @ViewChild("search_new") public searchElementRef: ElementRef;
  @ViewChild("langInput") langInput: ElementRef;
  storeList$: Observable<any>;
  aeropayForm: FormGroup;
  arpay: boolean = false;
  isAeropay: boolean;
  auth: any;
  storeAddress: any = "";
  loginCardSubmitted: boolean = false;
  driver_tip: any = 0;
  promo: FormGroup;
  cardImage: any = "";
  userData: any;
  selectOption: any;
  dateArray = [];

  sideMenu: any = [];
  creditCardArray: any = [];
  cvvLoginUser: any = "";
  selectedIndex: any;
  addNewCard: boolean = false;
  progressbarWidthFlower: any = 0;
  CartBarLimitFlower: any = 0;
  weightLimitFlower: any = 0;
  guestProgressbarWidthFlower: any = "";
  guestCardSubmitted: boolean = false;
  userCardSubmitted: boolean = false;
  storeImage: any = "";
  timeSlotArray: any = [];
  storeAmount: any;
  isOptionSubmitted: boolean = false;
  paymentForm: FormGroup;
  guestModeOn: boolean = false;
  showShimmer: boolean;
  isSubmitted: boolean = false;
  cardType: string = "";
  currentDay;

  storeId: any;
  storeAccountNum: any;
  authorization: any;
  pamyentStatus: String = "Pending";
  paymentMessage: String = "";
  storeName: any;
  storeCurrentAddress: any;
  cartLength = 0;
  cartProduct$: Observable<any>;
  newCartsList: any;
  cartSum: any;
  userName: string;
  quantity = [];
  categoryName = "";
  pickupStoreListInThisRegion: any;
  cityForCheckStoreAmount;
  lat: any;
  lng: any;
  guestTexDetails: any;
  defaultUrl =
    "https://ams.iqmetrix.net/images/e02aa3c7-9b73-4153-b16b-5e8ab6ab1b2d";
  addressStreetNumber: any;
  addressPostalCode: any;
  addressRoute: any;
  addressLocality: any;
  addressAdministrationLevel: any;
  storeMobile: any = "";
  addressCountry: any;
  addressNeighborhood: any;
  addressCurrentLat: any;
  addressCurrentLong: any;
  addressFormattedAddress: any = "";
  addressSubLocality = "";
  governmentIDStatus = "";
  governmentIDMessage = "";
  cartMessageError = "";
  checkOutCartMessage = "";
  jun = moment();
  torrontoTime: any;
  est24Hours: any;
  currentHourMin: any;
  addressData: any;
  storeTiming: any;
  hideCartOption = true;
  timeSlotEnd = "";
  offlineCartProduct = [];
  addressString = "";
  guestAddForm: FormGroup;
  CreditCardForm_guest: FormGroup;
  CreditCardForm_login: FormGroup;
  spinData = [];
  activeSpin = false;
  showGovernmentMessage = false;
  searchInput = "";
  isSearchShow: boolean = false;
  hideCloseBtn = false;
  outOfStockMessage = "";
  offlineDiscountIn: any;
  offineDiscountNumber: any;
  offlineDiscountOn: any;
  carts: any = [];
  calculateOfflineDiscount = 0;
  offlineDeliveryCharge = 0;
  backendDeliveryCharge = 0;
  pickUpStoreList = [];
  oldDeliverySelectUserStatus: any;
  PickUpData;
  userId: string;
  addressCountryCode: string;
  status: any;
  formattedAddress: any[];
  CoordsListNEW: any[] = [];
  pickupAddress: any;
  addressState: string;
  addressCity: string;
  categoryListl$: Observable<any>;
  serverCategoryList: any;
  displayCategoryList: any[];
  selectedStoreName: any;
  selectedStoreAddress: string;
  marker = true;
  storeDetails: any;
  loginForm: FormGroup;
  addressStatus: string;
  addressLatitude: string;
  addressLongitude: string;
  postalCode: string;
  city: string;
  state: string;
  stateCode: string;
  country: string;
  countryCode: string;
  dilveryStatus: string;
  mobile: string;
  email: string;
  timiSelected: any = "null";

  registerForm: FormGroup;
  showReferralField: boolean;
  showAffilateField: boolean;
  submitted: boolean;
  mobileNumber: "";
  otpForm: FormGroup;
  verificationOTPForm: FormGroup;
  step: number = 1;
  distance: number;
  otpSubmitted: boolean;
  subCategoryName: any;
  selectedDate: any;
  selectedMillSecond: any;
  latitude_new: number;
  longitude_new: number;
  zoom_new: number;
  accuracy_new: number;
  address_new: string;
  deliveryInstruction;
  choosenTimeSlot = "null";
  selectedDeliveryTimeSlot = "";
  selectedTimeSlotDifference = "";
  slotColor = "#000";
  checkoutpart2Subtotal: any;
  checkoutpart2dilvery: any;
  checkoutpart2grandtotal: any;
  checkoutpart2tax: any;
  radiobtnonFor_inStore: Boolean = true;
  isDelivery: boolean = false;
  isordertype: any;
  orderCompleteDetails: any;
  userDetails: any;
  optionType: any = "";
  siteDada: any = "";
  IsGuest: boolean = false;
  ageVerification: any = "";
  socketService: any;
  allDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  splitTime;
  qtyValue;
  StoreClosed;
  tagList2 = [];
  progressbarWidth;
  showTimeSlotDiv;
  isPickup;
  guestProgressbarWidth;
  showLoading;
  COLOR;
  emptyArr;
  modalText;
  weekday;
  varqtyvalue;
  SPECIESLIST;
  Name = "";
  CurrentStoreData;
  currentOrderType: String = "";
  newOrderType: String = "";
  toChangeStatus;
  clickEventsubscription;
  storedatalocal;
  storeAdress: string;
  storeAddresss: any = "";
  registerData: any = "";
  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private userSrv: UserService,
    private router: Router,
    private loaderSrv: LoaderModalService,
    private _bs: BehaviorService,
    private cartLengthService: CartlengthService,
    private _dataLayerService: DataLayerServiceService,
    private appStateSvc: AppStateService,
  ) {
    this.socketService = AppInjector.get(ChatService);
    this.currentDay = moment.tz().format("dddd");
    let sideMenu = JSON.parse(sessionStorage.getItem("sideMenu"));
    if (sideMenu != undefined && sideMenu != "" && sideMenu != null) {
      this.sideMenu = sideMenu;
    }
    this._bs.getReload().subscribe((res) => {
      if (res == "Reload") {
        this.getData();
      }
    });

    setTimeout(() => {
      this.siteDada = JSON.parse(localStorage.getItem("siteData"));
    }, 300);
    this.createaeropayForm();
    this.getSideNavCOntent();
    this.initalizeCreditcard_loginForm();
    this.CreditCardForm_guestIntilize();
    this.orderType = localStorage.getItem("isPickUpOrder");
    let ageVerification = sessionStorage.getItem("ageVerification");
    this.ageVerification = JSON.parse(ageVerification);
    this.storeAddresss = localStorage.getItem("formattedAddress");
    localStorage.removeItem("addressString");
    localStorage.setItem("optionType", "PICKUP");
    this.isDelivery = false;
    let userDetails = localStorage.getItem("userDetails");
    this.userDetails = JSON.parse(userDetails);
  }

  ngOnInit(): void {
    this.connectSocket();

    this.registerData = JSON.parse(sessionStorage.getItem("registerData"));
    this.getStoreDetail();

    this._bs.get().subscribe((res) => {
      if (res == "card") {
        this.addNewCard = false;
        this.getUserData();
      }
    });
    this._bs.getRouterData().subscribe((res: any) => {
      if (res == "reload-page") {
        this.getUserData();
      }
    });

    this.userSrv.emitCartForAeropay().subscribe((res) => {
      if (res) {
        localStorage.setItem("optionType", "DELIVERY");
        this.radiobtnonForCash_auth = true;
        this.canShowThankyoupage = false;
        this.showPlaceOrderDiv = true;
        this.showTimeSlotDiv = false;
        this.optionType = "DELIVERY";
        this.isAeropay = true;
        let aeropayForm: any = this.appStateSvc.stateData.aeroPayUser;
        this.getUserData();
        aeropayForm = JSON.parse(aeropayForm);
        if (aeropayForm) {
          this.aeropayForm.patchValue(aeropayForm);
        }
      }
    });
    let store = JSON.parse(localStorage.getItem("storeInfo"));
    this.storeImage = store?.image;
    let userId = localStorage.getItem("covaUserId");
    if (userId) {
      this.userId;
    }
    let optionType: any = localStorage.getItem("optionType");
    this.showTimeSlotAccToType(optionType ? optionType : "PICKUP");

    this.commonService.invokecartGuestFunction().subscribe(() => {
      this.resetGuestCart_1stscreen();
    });
    localStorage.setItem("isSwitch", "false");
    this.storeCurrentAddress = localStorage.getItem("addressString");
    this.isPickup = JSON.parse(localStorage.getItem("isPickUpOrder"));
    this.canRequest = true;
    this.varqtyvalue = 0;
    this.getDateArray();

    this.CartBarLimit = Number(localStorage.getItem("CartBarLimit"));
    this.CartBarLimitFlower = Number(
      localStorage.getItem("CartBarLimitFlower"),
    );
    this.weekday = new Date().toLocaleString("en-us", { weekday: "long" });
    this.commonService.getPurchasaeLimit().subscribe((res) => {
      if (res["meta"]["status"]) {
        if (res["data"]["limitvalue"]) {
          this.CartBarLimit = Number(res["data"]["limitvalue"]);
          localStorage.setItem("CartBarLimit", this.CartBarLimit);
        }
        if (res["data"]["flowerLimitValue"]) {
          this.CartBarLimitFlower = Number(res["data"]["flowerLimitValue"]);
          localStorage.setItem("CartBarLimitFlower", this.CartBarLimitFlower);
        }
      }
    });
    if (
      localStorage.getItem("addressStatus") === undefined ||
      localStorage.getItem("addressStatus") === null
    ) {
      return;
    } else {
      this.emptyArr = [];
      this.modalText = "";
      this.COLOR = "";
      this.showTimeSlotDiv = false;
      this.showPlaceOrderDiv = false;
      this.showLoading = false;
      this.guestCartWeight = 0;
      this.isPickup = JSON.parse(localStorage.getItem("isPickUpOrder"));
      this.getEstTime();
      this.progressbarWidth = "25%";
      this.guestProgressbarWidth = "0%";
      this.defaultUrl = "assets/images/defaultimg.jpeg"; //default image
      this.guestModeOn = false;
      this.qtyValue = 1;
      this.createLoginForm();
      this.createRegisterForm();
      this.createOTPForm();
      this.createVerificationOTPForm();
      this.guestAddFormIntilize(); // guest form intitalize

      this.isPickup = localStorage.getItem("isPickUpOrder");
      this.gettingTimeSlot();

      this.isPickup = localStorage.getItem("isPickUpOrder");
      if (this.isPickup == "true") {
        this.modalText = "pickup";
      } else {
        this.modalText = "delivery";
      }
      this.StoreClosed = false;
      this.userName = localStorage.getItem("userName");
      this.commonService.pickUpStore("").subscribe((res) => {
        this.pickUpStoreList = res;
        let currentstoreid = Number(localStorage.getItem("localStoreId"));
        this.CurrentStoreData = this.pickUpStoreList?.find(
          (a) => a?.Id == currentstoreid,
        );
        var coordinates_array = [];
        let lat2: number;
        let lon2: number;
        for (let i = 0; i < res.length; i++) {
          coordinates_array.push(this.pickUpStoreList[i]?.coordinates);
          lat2 = coordinates_array?.[i]?.[0];
          lon2 = coordinates_array?.[i]?.[1];
        }
        this.saveSortingResultDistance();
      });

      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $("#scroll").fadeIn();
        } else {
          $("#scroll").fadeOut();
        }
      });
      $("#scroll").click(function () {
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
      });
      if (
        localStorage.getItem("addressString") === undefined ||
        localStorage.getItem("addressString") === null
      ) {
        this.hideCloseBtn = false;
      } else {
        this.hideCloseBtn = true;
      }
      if (
        localStorage.getItem("isPickUpOrder") === undefined ||
        localStorage.getItem("isPickUpOrder") === null
      ) {
      } else {
        if (
          localStorage.getItem("addressStatus") === undefined ||
          localStorage.getItem("addressStatus") === null
        ) {
          $("#SearchLocation").modal("show");
          this.isPickup = localStorage.getItem("isPickUpOrder");
        }
      }

      $(window).on("scroll", function () {
        let top = $(window).scrollTop();
        if (top >= 30) {
          $(".sticky-header").addClass("fixed");
          $(".select-address-header").addClass("fixed");
        } else {
          $(".sticky-header").removeClass("fixed");
          $(".select-address-header").removeClass("fixed");
        }
      });
      this.checkValueInSearch();
      this.createForm();
      this.addressString = localStorage.getItem("addressString");
      if (localStorage.getItem("isPickUpOrder") == "false") {
        if (
          this.addressString == "undefined" ||
          this.addressString == undefined
        ) {
          this.addressString = "";
          localStorage.setItem("addressString", "");
        } else {
          this.addressString = localStorage.getItem("addressString");
        }
      }

      if (
        localStorage.getItem("localStoreId") === null ||
        localStorage.getItem("localStoreId") === undefined
      ) {
        if (
          localStorage.getItem("isPickUpOrder") === undefined ||
          localStorage.getItem("isPickUpOrder") === null
        ) {
        } else {
          if (
            localStorage.getItem("addressStatus") === undefined ||
            localStorage.getItem("addressStatus") === null
          ) {
            $("#SearchLocation").modal("show");
          }
        }
      } else {
        let obj = {
          storeId: Number(localStorage.getItem("localStoreId")),
          storeName: localStorage.getItem("localStoreName"),
          storeEmail: localStorage.getItem("storeEmail"),
        };
        this.storeId = Number(localStorage.getItem("localStoreId"));
        this.storeName = localStorage.getItem("localStoreName");
        this.storeAccountNum = localStorage.getItem("storeAccountNum");
        this.authorization = localStorage.getItem("authorization");

        this.storeMobile = localStorage.getItem("storeMobile");
        this.userSrv.updateStoreDetails(obj);
      }
      let obsrb = this.userSrv.getAuth().subscribe((res) => {
        this.auth = res;
        this.initalizeCreditcard_loginForm();
        if (this.auth) {
          this.userName = localStorage.getItem("userName");
        }
        this.checkUserEmailIDStatus();
        this.getAddress();
        if (res) {
        }
        if (localStorage.getItem("addressData") !== null) {
          this.saveUserAddressAfterLogin();
        }
        this.commonService.emitCartData().subscribe((data) => {
          if (this.auth) {
            this.getCartProduct();
          } else {
            this.getOfflineProduct();
          }
        });
      });
      obsrb.unsubscribe();
      for (var i = 1; i <= 50; i++) {
        this.quantity.push(i);
      }
      this.checkTimeSlot();
      this.selectedStoreName = localStorage.getItem("localStoreName");
      this.selectedStoreAddress = localStorage.getItem("addressString");

      this.isShown = false; //collect varient data
      this.showVariance = false;
    }

    this._bs.getCart().subscribe((data) => {
      if (this.auth) {
        this.getCartProduct();
      } else {
        this.getOfflineProduct();
      }
    });


interval(60000).subscribe(() => {
    const todaysDay = moment.tz().format("dddd");
    const isToday = this.currentDay === todaysDay;

  // if (isToday) {
  //   this.loadSlots();
  // }
});

  }

  connectSocket() {
    this.socketService.on("connected").subscribe((data: any) => {
      let datas = {
        room: "highlife4adda783-2521-4d8e-9330-e3a6679cc2f4",
      };
      this.socketService.emit("roomorder", datas);
    });
  }

  cardFOrmatLasr4Digit(item) {
    if (item) {
      var mainStr = item,
        vis = mainStr.slice(-4),
        countNum = "";

      for (var i = mainStr.length - 4; i > 0; i--) {
        countNum += "*";
      }
      return countNum + vis;
    }
  }

  GetCardTypeName(number: any) {
    if (number?.length < 15) {
      return "";
    }
    let value: any;
    var re = new RegExp("^4");
    if (number?.match(re) != null) {
      value = "Visa";
      return value;
    }
    if (
      /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
        number,
      )
    ) {
      value = "Mastercard";
      return value;
    }
    re = new RegExp("^3[47]");
    if (number?.match(re) != null) {
      value = "AMEX";
      return value;
    }
    re = new RegExp(
      "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)",
    );
    if (number?.match(re) != null) {
      value = "Discover";
      return value;
    }
    re = new RegExp("^36");
    if (number?.match(re) != null) {
      value = "Diners";
      return value;
    }
    re = new RegExp("^30[0-5]");
    if (number?.match(re) != null) {
      value = "Diners - Carte Blanche";
      return value;
    }
    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number?.match(re) != null) {
      value = "JCB";
      return value;
    }

    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number?.match(re) != null) {
      value = "Visa Electron";
      return value;
    }
    if (number == "") {
      return "";
    }
  }
  onPaste(event: ClipboardEvent, type) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData("text");
    let text = pastedText.split(" ").join("").toUpperCase();
    if (type == "guest") {
      this.CreditCardForm_guest.patchValue({
        pcode_guest: text,
      });
    } else {
      this.CreditCardForm_login.patchValue({
        pcode_login: text,
      });
    }
  }

  bankAccounts: any;
  getConnectedBanks(userID) {
    this.commonService.getConnectedBanks(userID).subscribe((res) => {
      if (res["meta"]["status"]) {
        this.bankAccounts = res["data"];
      }
    });
  }

  movileView() {
    if (window.innerWidth <= 768) {
      return true;
    } else {
      return false;
    }
  }

  getUserData() {
    let covaid = localStorage.getItem("covaUserId");
    this.creditCardArray = [];
    this.commonService.getUserProfile(covaid).subscribe((res: any) => {
      if (res["meta"]["status"]) {
        $("#loadMe").modal("hide");
        this.cvvLoginUser = "";
        this.userData = res.data;
        if (res["data"]?.aeropayUserBankInfo?.length > 0) {
          localStorage.setItem(
            "aeropayUserId",
            res["data"]?.aeropayUserBankInfo[0]?.userId,
          );
          this.getConnectedBanks(res["data"]?.aeropayUserBankInfo[0]?.userId);
        }
        localStorage.setItem("email", res["data"]["emailId"]);
        localStorage.setItem("mobile", res["data"]["mobile"]);
        this.creditCardArray = [];
        localStorage.setItem("userDetails", JSON.stringify(this.userData));
      }
    });
    return;
  }

  getSideNavCOntent() {
    this.commonService.getHOmeContent().subscribe((res) => {
      if (res["meta"]["status"]) {
        this.sideMenu = res["data"]["sideNavButton"];
        sessionStorage.setItem(
          "sideMenu",
          JSON.stringify(res["data"]["sideNavButton"]),
        );
        this.sideMenu = JSON.parse(sessionStorage.getItem("sideMenu"));
        if (res["data"]?.contactPage) {
          sessionStorage.setItem(
            "contactData",
            JSON.stringify(res["data"]["contactPage"]),
          );
        }
      }
    });
  }

  gettingTimeSlot() {
    if (this.isPickup == "true") {
      this.modalText = "pickup";
      this.commonService
        .getTimeSlotArrayFromDatabase(this.currentDay)
        .subscribe((res) => {
          this.timeSlotArrayFromDB = res;
          this.showTimeSlotAccToType(this.optionType);
        });
    } else {
      this.modalText = "delivery";
      this.commonService
        .getTimeSlotArrayFromDatabase(this.currentDay)
        .subscribe((res) => {
          this.timeSlotArrayFromDB = res;
          this.showTimeSlotAccToType(this.optionType);
        });
    }
  }

  saveSortingResultDistance() {
    let a = this.pickUpStoreList.sort((a, b) => {
      return a?.distanceInKms - b?.distanceInKms;
    });
  }

  createaeropayForm() {
    this.aeropayForm = this.fb.group({
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
          ),
        ],
      ],
      last_name: ["", Validators.required],
      phone_number: ["", [Validators.required, Validators.minLength(10)]],
      first_name: ["", Validators.required],
    });
  }

  get af() {
    return this.aeropayForm.controls;
  }

  initalizeCreditcard_loginForm() {
    this.CreditCardForm_login = this.fb.group({
      cvv_login: ["", [Validators.required, Validators.minLength(3)]],
      cardnumber_login: ["", [Validators.required, Validators.minLength(16)]],
      pcode_login: ["", [Validators.required, Validators.minLength(6)]],
      expiryYear_login: ["", [Validators.required]],
      expiryMonth_login: ["", [Validators.required]],
      street_address: ["", [Validators.required]],
      city_address: ["", [Validators.required]],
      state_address: ["", [Validators.required]],
      country_address: ["US", [Validators.required]],
      firstname_login: ["", [Validators.required]],
      lastname_login: ["", [Validators.required]],
      email_login: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
      phone_login: ["", [Validators.required, Validators.minLength(10)]],
      apartment: ["", ""],
      newCard_user: ["false"],
      saveCard_user: ["false"],
      selectCard: ["false"],
    });
  }
  get UF() {
    return this.CreditCardForm_login.controls;
  }

  get pf() {
    return this.guestAddForm.controls;
  }

  // resetGuestCart_1stscreen() {
  //   this.canShowThankyoupage = false;
  //   this.showTimeSlotDiv = false;
  //   this.showPlaceOrderDiv = false;
  //   this.guestModeOn = false;
  //   this.getOfflineProduct();
  // }
  resetGuestCart_1stscreen() {
    this.canShowThankyoupage = false;
    this.showTimeSlotDiv = false;
    this.showPlaceOrderDiv = false;
    this.guestModeOn = false;

    // Clear any guest-specific data
    localStorage.removeItem("guestToken");
    localStorage.removeItem("guestKey");

    // Reset guest form
    this.guestAddForm.reset();
    this.submitted = false;

    // Get the original offline products (without promo modifications)
    this.getOfflineProduct();

    // Reset step to 1
    this.step = 1;
  }

  ngAfterViewInit() {
    this.userSrv.getStore().subscribe((res) => {
      if (res === null) {
        this.storeId = "";
        this.storeName = "";
        this.storeAccountNum = "";
        this.authorization = "";
      } else {
        this.storeId = Number(res["storeId"]);
        this.storeName = res["storeName"];
        this.storeAccountNum = res["storeAccountNum"];
        this.authorization = res["authorization"];
      }
    });
  }

  openstorepop(val) {
    this.optionType = val;
    this.showTimeSlotAccToType(this.optionType);

    if (this.optionType != "DELIVERY") {
      this.addressString = "";
      this.addressFormattedAddress = "";
      localStorage.removeItem("addressString");
    }

    localStorage.setItem("optionType", val);
    this.optionType = val;
    if (this.optionType == "PICKUP") {
      this.radiobtnonFor_inStore = true;
      localStorage.setItem("isPickUpOrder", "true");
      this.isDelivery = false;
      var currentLastStoreAddress = localStorage.getItem("storeCurrentAddress");
      localStorage.setItem("addressString", currentLastStoreAddress);
      this.addressString = currentLastStoreAddress;
      this.storeCurrentAddress = currentLastStoreAddress;
      localStorage.setItem("isPickUpOrder", "true");
    } else if (this.optionType == "CURBSIDE") {
      this.radiobtnonFor_inStore = false;
      this.isDelivery = false;
      var currentLastStoreAddress = localStorage.getItem("storeCurrentAddress");
      localStorage.setItem("addressString", currentLastStoreAddress);
      this.addressString = currentLastStoreAddress;
      this.storeCurrentAddress = currentLastStoreAddress;
      localStorage.setItem("isPickUpOrder", "true");
    } else {
      this.radiobtnonFor_inStore = false;
      this.isDelivery = true;
      this.addressString = "";
      localStorage.setItem("isPickUpOrder", "false");
      localStorage.setItem("addressString", this.addressFormattedAddress);
    }
  }

  add2HourTimeSlot(time: any) {
    if (time != undefined && time != null && time != "") {
    }
    let item: any = time.split("-");
    let T1: any = item[0].split(":");
    let T2 = item[1].split(":");
    let updatedTIme: any =
      Number(T1[0]) + ":" + T1[1] + "-" + Number(T2[0]) + ":" + T2[1];
    return updatedTIme;
  }

  getOptionType() {
    this.optionType = localStorage.getItem("optionType");
    return this.optionType;
  }

  newStoreHoursFormat(hour, min) {
    var newFormatedValue = hour + ":" + min;
    return moment(newFormatedValue, ["HH:mm"]).format("h:mm A");
  }

  showTimeSlotAccToType(type: string) {
    if (!this.storeDetails) return;
    this.optionType = type || localStorage.getItem("optionType") || "";
    this.storeTime = type === "DELIVERY" ? this.storeDetails["DeliveryHours"]?.[this.currentDay] : this.storeDetails["StoreHours"]?.[this.currentDay];
    if (this.storeTime?.isOpen) {
      this.timeSlotArrayAll = [];
      this.timeSlotArray = [];
      this.timiSelected = null;
      this.choosenTimeSlot = "";
      this.selectedDeliveryTimeSlot = "";
      this.selectedTimeSlotDifference = "";
      return;
    }
    this.timeSlotArrayAll = [];
    this.timeSlotArrayAll = this.filterValidSlots(this.optionType, this.storeTime);    
    if (this.timeSlotArrayAll?.length < 1) {
      this.timeSlotArray = [];
      this.timiSelected = null;
      this.choosenTimeSlot = "";
      this.selectedDeliveryTimeSlot = "";
      this.selectedTimeSlotDifference = "";
    }

    this.updateTimeSlotsForSelectedDate();
    if (this.timeSlotArray?.length) {
      this.timiSelected = this.timeSlotArray[0]?.value;
    }
    this.onChange(this.timiSelected);
  }


  private updateTimeSlotsForSelectedDate() {
    if (!this.timeSlotArrayAll?.length) return;
    this.timeSlotArray = [];
    const today = moment().format("YYYY-MM-DD");
    const selected = moment(this.selectedDate).format("YYYY-MM-DD");

    if (selected === today) {
      // Today → filter slots after current time + buffer
      const buffer = moment.duration("00:29:00");
      const currentTime = moment();

      this.timeSlotArray = this.timeSlotArrayAll.filter((slot) => {
        const endTime = moment(slot.value.split("-")[1], "HH:mm").subtract( buffer);
        return currentTime.isBefore(endTime);
      });
    } else {
      // Future date → show all slots      
      this.timeSlotArray = [...this.timeSlotArrayAll];      
    }

    if (this.timeSlotArray.length) {
      this.timiSelected = this.timeSlotArray[0]?.value;
    } else {
      this.timiSelected = null;
    }
  }

  /**
   * Reusable function to filter DB slots based on store hours
   */
  private filterValidSlots(optionType: string,storeTime: any): any[] {
    const result: any[] = [];
    const todaysDay = moment.tz().format("dddd");
    const isToday = this.currentDay === todaysDay;  

    if (!this.timeSlotArrayFromDB?.length || !storeTime) {
      return result;
    }

    const slotGroup = this.timeSlotArrayFromDB.find(s => s?.slotName === optionType);
    if (!slotGroup?.slot?.length) {
      return result;
    }
    const now = new Date();

    const currentMinutes =
      now.getHours() * 60 + now.getMinutes();

    const openMinutes = storeTime.Open.Hour * 60 + storeTime.Open.Minute;

    const closeMinutes = storeTime.Close.Hour * 60 + storeTime.Close.Minute;

    // Store already closed today
    if (isToday && currentMinutes >= closeMinutes) {
      return [];
    }

  slotGroup.slot.forEach((time) => {
    const [start] = time.value.split('-');

    const [startHour, startMinute] = start.split(':').map(Number);

    const startMinutes = startHour * 60 + startMinute;

    // Don't show slots that start after store closing
    if (
      startMinutes < openMinutes ||
      startMinutes > closeMinutes
    ) {
      return;
    }

    result.push({
      _id: time._id,
      color: time.color,
      value: this.add2HourTimeSlot(time.value),
    });
  });

    return result;
  }

  
  checkTimeSlot() {
    this.jun.tz("America/Los_Angeles").format("hh : mm : ss a z");
    this.torrontoTime = this.jun
      .tz("America/Los_Angeles")
      .format("hh : mm : ss a z");
    this.est24Hours = this.convertTo24Hour(this.torrontoTime);
    var splitTime = this.est24Hours.split(":");
    this.currentHourMin = Number(splitTime[0]) * 60 + Number(splitTime[1]);
  }

  convertTo24Hour(time) {
    var hours = parseInt(time.substr(0, 2));
    if (time.indexOf("am") != -1 && hours == 12) {
      time = time.replace("12", "0");
    }
    if (time.indexOf("pm") != -1 && hours < 12) {
      time = time.replace(hours, hours + 12);
    }
    return time.replace(/(am|pm)/, "");
  }

  saveDeliverAddressAfterLogin() {
    //
    this.userId = localStorage.getItem("covaUserId");
    this.userName = localStorage.getItem("userName");
    let obj: any;

    if (localStorage.getItem("optionType") == "DELIVERY") {
      obj = {
        CustomerId: this.userId,
        AddressTypeId: 2,
        AttentionTo: this.userName,
        CountryCode: this.addressCountry,
        Default: false,
        DoNotContact: true,
        Email: "",
        Locality: this.addressLocality,
        Notes: this.addressRoute,
        Phone: "",
        PostalCode: this.addressPostalCode,
        PostOfficeBoxNumber: this.addressRoute,
        StateCode: this.addressAdministrationLevel,
        StreetAddress1: this.addressFormattedAddress,
        StreetAddress2: this.addressSubLocality,
        currentLat: this.addressCurrentLat
          ? this.addressCurrentLat
          : 49.31820997936569,
        currentLong: this.addressCurrentLong
          ? this.addressCurrentLong
          : -124.29653501338164,
        formattedAddress: this.addressFormattedAddress,
      };
    } else {
      obj = {
        CustomerId: this.userId,
        AddressTypeId: 2,
        AttentionTo: this.userName,
        CountryCode: "US",
        Default: false,
        DoNotContact: true,
        Email: "",
        Locality: localStorage.getItem("city"),
        Notes: this.addressRoute,
        Phone: "",
        PostalCode: localStorage.getItem("postal_code"),
        PostOfficeBoxNumber: this.addressRoute,
        StateCode: localStorage.getItem("stateCode"),
        StreetAddress1: localStorage.getItem("storeCurrentAddress"),
        StreetAddress2: localStorage.getItem("storeCurrentAddress"),
        currentLat: localStorage.getItem("addressLatitude")
          ? localStorage.getItem("addressLatitude")
          : 49.31820997936569,
        currentLong: localStorage.getItem("addressLongitude")
          ? localStorage.getItem("addressLongitude")
          : -124.29653501338164,
        formattedAddress: localStorage.getItem("storeCurrentAddress"),
      };
    }

    this.commonService.saveAddress(obj).subscribe((res) => {
      if (res["meta"]["status"]) {
        let address = res["data"];
        this.getAddress();
        localStorage.setItem("addressId", address?.Id);
        localStorage.setItem("SavedAddress", JSON.stringify(address));
        localStorage.setItem("addressStatus", "true");
        localStorage.setItem("addressLatitude", address?.currentLat);
        localStorage.setItem("addressLongitude", address?.currentLong);
        if (address?.PostalCode) {
          localStorage.setItem("postal_code", address?.PostalCode);
          localStorage.setItem("StateCode", address?.StateCode);
        }
        if (address?.Country) {
          localStorage.setItem("country", address?.Country);
        }
        localStorage.setItem("street_number", this.addressStreetNumber);
        localStorage.setItem("route", this.addressRoute);
        localStorage.setItem("locality", address?.Locality);
        localStorage.setItem(
          "administrative_area_level_1",
          this.addressAdministrationLevel,
        );
        localStorage.setItem("neighborhood", this.addressNeighborhood);
        localStorage.setItem("sublocality", this.addressSubLocality);
        localStorage.removeItem("addressData");
        localStorage.setItem("state", address?.State);
        localStorage.setItem("formattedAddress", address?.formattedAddress);
      } else {
      }
      return false;
    });
  }

  selectMailOrderFromHeader(status) {
    $("#ageVerify").modal("show"); //Age Verification
  }

  checkValueInSearch() {
    this.activatedRoute.queryParams.subscribe((res) => {
      this.searchInput = res["search"];
    });
  }

  dilverytime;

  manageOrderOption(type: any) {
    return this.storeDetails?.services.some((s) => s.includes(type));
  }

  manageOrderOptions(type: any) {
    if (
      this.storeDetails?.services.some((s) => s.includes(type)) &&
      type == "Delivery"
    ) {
      return "Delivery ";
    }

    if (
      this.storeDetails?.services.some((s) => s.includes(type)) &&
      type == "Pickup"
    ) {
      return " Store  Pickup ";
    }

    if (
      this.storeDetails?.services.some((s) => s.includes(type)) &&
      type == "CurbsidePickup"
    ) {
      return " Curbside Pickup";
    }

    return;
  }

  getStoreDetail() {
    const obj = {
      Id: Number(localStorage.getItem("localStoreId")),
    };

    this.commonService.getStoreDetail(obj).subscribe((res) => {
      this.storeAddress = res["data"]?.Address;
      this.storeDetails = res["data"];
      localStorage.setItem(
        "addressLatitude",
        res["data"]?.location?.coordinates[1],
      );
      localStorage.setItem(
        "addressLongitude",
        res["data"]?.location?.coordinates[0],
      );
      this.storeMobileNumber = res["data"];
      let weekday = new Date().toLocaleString("en-us", { weekday: "long" });
      if (this.storeDetails && this.storeDetails["StoreHours"]) {
        let a = this.storeDetails["StoreHours"][weekday];
        this.storeTime = a;
      }

      if (
        this.storeDetails &&
        this.storeDetails["StoreHours"] &&
        this.storeDetails["DeliveryHours"][weekday]
      ) {
        let a = this.storeDetails["StoreHours"][weekday];
        let optionType: any = localStorage.getItem("optionType");
        this.showTimeSlotAccToType(optionType ? optionType : "PICKUP");

        let dilveryHoursObj = this.storeDetails["DeliveryHours"][weekday];
        var currentTime = moment(new Date());
        var StoreOpenTime = a?.Open?.Hour + ":" + a?.Open?.Minute;
        var StoreCloseTime = a.Close.Hour + ":" + a.Close.Minute;
        var endTime: any;
        var beginningTime = moment(StoreOpenTime, "HH:mm");
        if (StoreCloseTime == "0:0") {
          StoreCloseTime = "24:0";
        }
        if (a.Close.Hour < a.Open.Hour && a.Close.Hour != "0") {
          endTime = moment(StoreCloseTime, "HH:mm").add(1, "day");
        } else {
          endTime = moment(StoreCloseTime, "HH:mm");
        }

        if (currentTime > beginningTime && currentTime < endTime) {
          this.StoreClosed = false;
        } else {
          this.StoreClosed = true;
        }
        if (a) {
          this.dilverytime = dilveryHoursObj;
          localStorage.setItem("storeTiming", JSON.stringify(a));
        }
      }
    });
  }

  CreditCardForm_guestIntilize() {
    this.CreditCardForm_guest = this.fb.group({
      cvv_guest: ["", [Validators.required, Validators.minLength(3)]],
      cardnumber_guest: ["", [Validators.required, Validators.minLength(16)]],
      pcode_guest: ["", [Validators.required, Validators.minLength(6)]],
      expiryYear_guest: ["", [Validators.required]],
      expiryMonth_guest: ["", [Validators.required]],
      street_address_guest: ["", [Validators.required]],
      city_address_guest: ["", [Validators.required]],
      state_address_guest: ["", [Validators.required]],
      country_address_guest: ["US", ""],
      firstname_guest: ["", [Validators.required]],
      lastname_guest: ["", [Validators.required]],
      email_guest: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
      phone_guest: ["", [Validators.required, Validators.minLength(10)]],
      apartment: ["", ""],
    });

    this.CreditCardForm_guest.controls["country_address_guest"].disable();
  }

  get F() {
    return this.CreditCardForm_guest.controls;
  }

  guestAddFormIntilize() {
    this.guestAddForm = this.fb.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      email: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
      mobile: ["", [Validators.required, Validators.minLength(10)]],
      // postalCode: [""],
    });
  }

  createOTPForm() {
    this.otpForm = this.fb.group({
      mobileNumber: [
        "",
        [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")],
      ],
    });
  }

  createRegisterForm() {
    this.registerForm = this.fb.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      emailId: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/),
        ],
      ],
      password: ["", [Validators.required, Validators.minLength(6)]],
      dob: ["", [Validators.required]],
    });
  }

  createLoginForm() {
    this.loginForm = this.fb.group({
      emailId: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/),
        ],
      ],
      password: ["", [Validators.required]],
    });
  }

  torontoDate;
  nextTorontoDate;
  nextDay;
  getEstTime() {
    this.torontoDate = this.jun.tz("America/Los_Angeles").format("YYYY-MM-DD");
    // this.currentDay = moment.tz("America/Los_Angeles").format("dddd");
    this.nextTorontoDate = this.jun
      .tz("America/Los_Angeles")
      .add(1, "days")
      .format("YYYY-MM-DD");
    this.nextDay = moment
      .tz("America/Los_Angeles")
      .add(1, "days")
      .format("dddd");
    this.jun.tz("America/Los_Angeles").format("hh : mm : ss a z");
    this.torrontoTime = this.jun
      .tz("America/Los_Angeles")
      .format("hh : mm : ss a z");
    this.est24Hours = this.convertTo24Hour(this.torrontoTime);
    var splitTime = this.est24Hours.split(":");
    this.currentHourMin = Number(splitTime[0]) * 60 + Number(splitTime[1]);
  }

  createVerificationOTPForm() {
    this.verificationOTPForm = this.fb.group({
      otp: ["", [Validators.required]],
    });
  }

  // GOTO REGISTER
  openLogin() {
    document.getElementById("mySideRegister").style.width = "0";
    document.getElementById("mySideLogin").style.width = "450px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideLogin").style.width = "calc(100%)";
      }
    }

    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal = document.getElementById("mySideLogin");
    modal.focus();
  }
  // CLOSE POP UP
  openLogoutPopUp() {
    $("#logoutPopUp").modal("show");
  }

  storeTime;
  storeMobileNumber;
  openStoreTimeModal3() {
    this.showLoading = true;
    $("#storeOpenCloseTimeing2").modal("show");
    this.getData();
  }

  getData() {
    let obj = {
      Id: localStorage.getItem("localStoreId"),
    };
    this.commonService.getStoreDetail(obj).subscribe((res) => {
      let a = res["data"];
      this.storeAddresss = a?.Address?.AddressLine2;
      this.storeMobileNumber = a?.storeMobile;
      this.showLoading = false;
    });
  }

  loginModeOn: Boolean = false; // to showtime slot and c
  redirectToCheckOutPage(type) {
    let userDetails = localStorage.getItem("userDetails");
    if (this.auth) {
      this.getAddress();
      this.getUserData();
      this.commonService.emittedCartValue.next(true);
    }
    this.userDetails = JSON.parse(userDetails);
    if (
      this.auth &&
      this.registerData &&
      !this.userDetails?.mobileVerified &&
      this.registerData?.verifyMobile
    ) {
      $("#shoppingCart").modal("hide");

      document.getElementById("mySideLogin").style.width = "0";

      document.getElementById("mySideRegister").style.width = "0";

      document.getElementById("mySideMobileVerify").style.width = "450px";
      function myFunction(x) {
        if (x.matches) {
          document.getElementById("mySideMobileVerify").style.width =
            "calc(100%)";
        }
      }
      var x = window.matchMedia("(max-width: 580px)");
      myFunction(x);
      x.addEventListener("click", myFunction);
      const modal = document.getElementById("mySideMobileVerify");
      modal.focus();
      this._bs.routerData("using_cart");
      return;
    }
    if (type != "login") {
      this.step = 2;
    }
    this.gettingTimeSlot();
    if (!this.auth) {
      $("#shoppingCart").modal("hide");
      this.openLogin();
    } else {
      let checkDilvery = localStorage.getItem("isPickUpOrder");
      if (checkDilvery == "false") {
        this.selected_date_text = "Select Delivery Date ";
      } else {
        this.selected_date_text = "Select Pickup Date ";
      }
      this.addressString = localStorage.getItem("addressString");
      this.isPickup = localStorage.getItem("isPickUpOrder");
      this.loginModeOn = true;
      this.showLoginStaffPick = false;
      this.showTimeSlotDiv = true;
      this.getCartProduct();
    }
    window.scrollTo(0, 0);
  }

  getDigitwithoutzero(digit) {
    if (!this.auth) {
      let offlineProduct = JSON.parse(localStorage.getItem("cartProduct"));
      let currentcartWeight: any = 0;
      let currentcartFlowerWeight: any = 0;
      this.guestProgressbarWidth = 0;
      this.progressbarWidthFlower = 0;
      if (
        offlineProduct &&
        offlineProduct["product"] &&
        offlineProduct["product"]?.length
      ) {
        offlineProduct["product"].forEach((cartPd) => {
          if (this.CartBarLimitFlower > 0) {
            if (cartPd?.categoryId == 2543) {
              let weight = 0;
              weight = cartPd?.weight * cartPd["quantity"];
              currentcartFlowerWeight = weight + currentcartFlowerWeight;
              this.progressbarWidthFlower = currentcartFlowerWeight + "%";
              this.weightLimitFlower = currentcartFlowerWeight;
            }
            if (cartPd?.categoryId != 2543) {
              let weight = 0;
              weight = cartPd?.weight * cartPd["quantity"];
              currentcartWeight = weight + currentcartWeight;
              this.guestProgressbarWidth = currentcartWeight + "%";
              this.guestCartWeight = currentcartWeight;
            }
          } else {
            let weight = 0;
            weight = cartPd?.weight * cartPd["quantity"];
            currentcartWeight = weight + currentcartWeight;
            this.guestProgressbarWidth = currentcartWeight + "%";
            this.guestCartWeight = currentcartWeight;
          }
        });
      }
    }
    if (Number(digit) % 2 != 0) {
      var newValue = digit?.toString()?.split(".");
      if (newValue?.length == 2) {
        if (newValue[1].toString().length == 1) {
          return digit;
        } else {
          var newValue2 = newValue[1].substring(1, 2);
          var newValue21 = newValue[1].substring(0, 1);
          if (newValue2 == 0) {
            if (newValue21 == 0) {
              return Number(digit).toFixed(0);
            } else {
              return Number(digit).toFixed(1);
            }
          } else {
            return Number(digit).toFixed(2);
          }
        }
      } else {
        return digit;
      }
    } else {
      return parseFloat(digit);
    }
  }

  getSubTotal(value) {
    return Number(value);
  }

  getMin(digit) {
    if (digit == "0") {
      digit = "";
    }

    if (Number(digit) < 10 && Number(digit) != 0) {
      digit = `:0${digit}`;
    }

    if (Number(digit) > 10) {
      digit = `:${digit}`;
    }

    if (Number(digit) == 10) {
      digit = `:${digit}`;
    }

    return digit;
  }

  submit() {
    if (this.promo.valid) {
    }
    setTimeout(() => {
      document.getElementById("hideafter5").style.visibility = "hidden";
    }, 5000);
  }

  getDateArray() {
    this.dateArray = [];
    for (var i = 0; i <= 1; i++) {
      let date;
      let days;
      let milliSecond;
      if (i === 0) {
        days = moment().add(i, "days").format("dddd");
        date = moment(new Date()).format("YYYY-MM-DD");
        milliSecond = moment(new Date()).valueOf();

        this.dateArray.push({
          date: date,
          day: days,
          milliSecond: milliSecond,
          same: 0,
        });
      } else {
        days = moment(new Date()).add(i, "days").format("dddd");
        date = moment(new Date()).add(i, "days").format("YYYY-MM-DD");
        let ld = moment(date)["_d"];
        let ls = new Date(ld);
        milliSecond = moment(new Date(ls)).valueOf();
        this.dateArray.push({
          date: date,
          day: days,
          same: 1,
          milliSecond: milliSecond,
        });
      }
    }
    this.selectedDate = this.dateArray[0].date;
    this.selectedMillSecond = this.dateArray[0].milliSecond;
  }

  guestCartWeight: number = 0;
  getOfflineProduct() {
    if (localStorage.getItem("cartProduct") === null) {
      this.cartLength = 0;
      this.guestProgressbarWidth = "0%";
      this.guestProgressbarWidthFlower = "0%";
      localStorage.removeItem("cartProduct");
    } else {
      let offlineProduct = JSON.parse(localStorage.getItem("cartProduct"));

      // Filter out free products that were added by promo
      if (offlineProduct && offlineProduct["product"]) {
        this.offlineCartProduct = offlineProduct["product"].filter(
          (product) => !product.isfree || product.price > 0.01,
        );

        // Update localStorage with filtered products
        if (
          this.offlineCartProduct.length !== offlineProduct["product"].length
        ) {
          offlineProduct["product"] = this.offlineCartProduct;
          localStorage.setItem("cartProduct", JSON.stringify(offlineProduct));
        }
      }

      if (this.offlineCartProduct.length === 0) {
        localStorage.removeItem("cartProduct");
        this.guestProgressbarWidth = "0%";
        this.guestProgressbarWidthFlower = "0%";
        this.cartLength = 0;
      }

      this.cartLength = this.offlineCartProduct.length;

      // Rest of your existing calculation logic...
      let currentcartWeight = 0;
      if (offlineProduct["product"]) {
        offlineProduct["product"].forEach((cartPd) => {
          if (cartPd?.categoryId != 2543) {
            currentcartWeight =
              currentcartWeight + cartPd.weight * cartPd.quantity;
            this.guestCartWeight = Number(currentcartWeight);
          }
        });
      }

      let percentage = (currentcartWeight / this.CartBarLimit) * 100;
      let percentageFlower =
        (currentcartWeight / this.CartBarLimitFlower) * 100;

      if (currentcartWeight) {
        this.guestProgressbarWidth = String(percentage.toFixed(0)) + "%";
      } else {
        this.guestProgressbarWidth = String(percentage.toFixed(0) + "%");
      }

      if (currentcartWeight) {
        this.guestProgressbarWidthFlower =
          String(percentageFlower.toFixed(0)) + "%";
      } else {
        this.guestProgressbarWidthFlower = String(
          percentageFlower.toFixed(0) + "%",
        );
      }

      localStorage.setItem("cartLimit", this.weightLimit);

      if (this.cartLength >= 1) {
        this.getRecommendedProduct();
      }

      this.commonService.updateCartProduct(this.cartLength);
    }
  }

  getAddress() {
    if (this.auth) {
      let covaid = localStorage.getItem("covaUserId");
      let obj = {
        CustomerId: covaid,
      };
      this.commonService.getUserLocation(obj).subscribe((res) => {
        if (res["meta"]["status"]) {
          let addressId = res["data"][0].Id;
          localStorage.setItem("addressId", addressId);
        } else {
          localStorage.removeItem("addressId");
        }
      });
    } else {
      this.addressString = localStorage.getItem("addressString");
    }
  }

  RECOMMNEDLIST;
  getRecommendedProduct() {
    let addedProductIds = [];
    if (this.offlineCartProduct.length) {
      this.offlineCartProduct.forEach((elm) => {
        addedProductIds.push(elm.productId);
      });
    }
    let obj = {
      storeId: this.storeId,
      categoryId: 2543,
      addedProductIds: addedProductIds,
      resPerPage: 3,
      page: 1,
    };

    this.commonService.getRecommendedPro(obj).subscribe((res) => {
      this.RECOMMNEDLIST = res["data"];
    });
  }

  checkUserEmailIDStatus() {
    this.userSrv.getAuth().subscribe((res) => {
      if (res) {
        this.userSrv.getUserAddedFromCSV().subscribe((x) => {
          if (x !== null) {
            if (x.userStatus === true) {
              if (x.emailVerified === false) {
                this.router.navigateByUrl("/verify/verify-email");
              } else {
                this.router.navigateByUrl("/verify/change-password");
              }
            }
          }
        });
      }
    });
  }

  timeSlotArrayFromDB = [];

  timeSlotArrayAll = [];
  showCreditCardForEntry_guest: Boolean = false;
  selectedPaymentMethod_guest = "cash";
  selectedPaymentMethod_auth = "cash";
  getPaymentMethodOption(status, value) {
    if (!this.auth) {
      this.selectedPaymentMethod_guest = value;

      if (value === "creditcard") {
        this.radiobtnonForCash_guest = false;
        this.showCreditCardForEntry_guest = true;
        localStorage.setItem("isCash", "false");
      }
      if (value == "cash") {
        this.radiobtnonForCash_guest = true;
        this.showCreditCardForEntry_guest = false;
        localStorage.setItem("isCash", "true");

        this.guestAddForm.patchValue({
          cardNumber: "",
          cvv: "",
          expiryDate: "",
        });
      }
    } else {
      this.selectedPaymentMethod_auth = value;
      if (value === "creditcard") {
        this.radiobtnonForCash_auth = false;
      }
      if (value == "cash") {
        this.radiobtnonForCash_auth = true;
        $("#userCard").val("2541112");
        $("#userCvv").val("");
        $("#userExpiryDate").val("");
      }
    }
  }

  createForm() {
    this.promo = this.fb.group({
      permo: ["", [Validators.required]],
    });
  }

  get cardNum() {
    return this.guestAddForm.get("cardNumber");
  }

  expirydatefun() {
    let value = "s";
  }

  saveUserAddressAfterLogin() {
    let addressData = JSON.parse(localStorage.getItem("addressData"));
    this.getAddressFromLocalStorage(
      addressData.name,
      addressData.address_components,
      addressData.geometry.location,
      addressData.formatted_address,
    );
  }

  getAddressFromLocalStorage(
    streetName,
    addressComponents,
    geometry,
    formattedAddress,
  ) {
    this.addressCurrentLat = geometry.lat;
    this.addressCurrentLong = geometry.lng;
    this.addressFormattedAddress = formattedAddress;
    this.addressStreetNumber = streetName;
    addressComponents.map((item) => {
      item.types.map((data) => {
        if (data === "postal_code") {
          this.addressPostalCode = item.long_name;
        } else if (data === "neighborhood") {
          this.addressNeighborhood = item.long_name;
        } else if (data === "locality") {
          this.addressLocality = item.long_name;
        } else if (data === "administrative_area_level_1") {
          this.addressAdministrationLevel = item.short_name;
        } else if (data === "country") {
          this.addressCountry = item.long_name;
        } else if (data === "route") {
          this.addressRoute = item.long_name;
        }
      });
    });
    this.saveDeliverAddressAfterLogin();
  }
  //cart empty
  landOnDashboeard() {
    location.reload();
  }
  updatePickUpStoreDataForHandler(
    storeId,
    storeName,
    addressLine1,
    addressLine2,
    city,
    state,
    stateCode,
    country,
    countryCode,
    zip,
    addressObj,
    lat,
    long,
    check,
  ) {
    //

    if (check == "false") {
      this.pickupAddress = addressLine2;
    } else {
      this.pickupAddress =
        addressLine1 + " " + city + " " + stateCode + " " + zip;
    }

    if (
      lat != undefined &&
      long != undefined &&
      lat != "undefined" &&
      long != "undefined"
    ) {
      localStorage.setItem("addressLatitude", lat);
      localStorage.setItem("addressLongitude", long);
    }

    this.selectedStoreAddress = this.pickupAddress;
    localStorage.setItem("addressString", this.pickupAddress);
    localStorage.setItem("addressStatus", "true");

    localStorage.setItem("postal_code", zip);
    localStorage.setItem("isPickUpOrder", check);
    localStorage.setItem("city", city);
    localStorage.setItem("state", state);
    localStorage.setItem("stateCode", stateCode);
    localStorage.setItem("country", country);
    localStorage.setItem("countryCode", countryCode);
    localStorage.setItem("dilveryStatus", "true");
    localStorage.setItem("localStoreId", storeId);
    localStorage.setItem("localStoreName", storeName);
    this.userId = localStorage.getItem("covaUserId");
    this.userName = localStorage.getItem("userName");
    let obj = {
      CustomerId: this.userId,
      AddressTypeId: 2,
      AttentionTo: this.userName,
      CountryCode: countryCode,
      Default: false,
      DoNotContact: true,
      Email: localStorage.getItem("email"),
      Locality: city,
      Notes: "",
      Phone: localStorage.getItem("mobile"),
      PostalCode: zip,
      PostOfficeBoxNumber: "",
      StateCode: stateCode,
      StreetAddress1: addressLine1,
      StreetAddress2: addressLine2,
      // currentLat: lat,
      // currentLong: long,
      currentLat: Number(localStorage.getItem("addressLatitude"))
        ? Number(localStorage.getItem("addressLatitude"))
        : Number(localStorage.getItem("currentLat")),
      currentLong: Number(localStorage.getItem("addressLongitude"))
        ? Number(localStorage.getItem("addressLongitude"))
        : Number(localStorage.getItem("currentLong")),
      formattedAddress: this.pickupAddress,
    };
    if (this.auth) {
      this.commonService.saveAddress(obj).subscribe((res) => {
        $("#SearchLocation").modal("hide");
        setTimeout(() => {
          location.reload();
        }, 1000);
      });
    } else {
      $("#SearchLocation").modal("hide");
      if (localStorage.getItem("isSwitch") == "true") {
        localStorage.setItem("isSwitch", "false");
        localStorage.removeItem("cartProduct");
        localStorage.removeItem("cartProduct");
      }
      setTimeout(() => {
        location.reload();
      }, 1000);
    }
  }

  limitCheckUser(addingProductWeight) {
    let usercart = this.logincartProduct["data"]["addtoCart"];
    let currentCartWeight = 0;
    usercart.forEach((elem) => {
      currentCartWeight =
        currentCartWeight + elem.EquivalentToVal * elem.selectQuantity;
    });
    let weightToCompare = currentCartWeight + addingProductWeight;
    if (weightToCompare > this.CartBarLimit) {
      return true;
    } else {
      return false;
    }
  }

  calulateOnly_cartDiscount(cart) {
    var Quantity = ""; //  key is not common show;
    if (this.auth) {
      Quantity = "selectQuantity";
    } else {
      Quantity = "quantity";
    }
    if (cart) {
      let discontedprdouctArray = cart;
      var total_sumOfPrice = 0;
      var total_sumOfMyPrice = 0;

      discontedprdouctArray.forEach((a) => {
        //price
        let price = Number(a.price);
        let qty = Number(a[`${Quantity}`]);
        let total = price * qty;
        total_sumOfPrice = total_sumOfPrice + total;
        //my price
        let myprice = Number(a.myPrice);
        let myqty = Number(a[`${Quantity}`]);
        let mytotal = myprice * myqty;
        total_sumOfMyPrice = total_sumOfMyPrice + mytotal;
      });
      let totalcartDisc = Number(total_sumOfMyPrice) - Number(total_sumOfPrice);

      return Number(totalcartDisc.toFixed(2));
    } else {
      return 0;
    }
  }

  showLoginStaffPick: Boolean = false;
  recommendedProductsList;
  weightLimit;
  CompareWithSubTotal;
  CartSubTotal;
  CartBarLimit;
  logincartProduct;
  logincartProductList = [];
  cardNumErr;

  getCartProduct() {
    var isSwitchStatus = false;
    var storeID = localStorage.getItem("localStoreId");
    if (localStorage.getItem("isSwitch") == "true") {
      isSwitchStatus = true;
    } else {
      isSwitchStatus = false;
    }
    this.showShimmer = true;
    this.commonService
      .getCartProductWithoutRecomandedPrd(isSwitchStatus, storeID)
      .subscribe((res: any) => {
        this.showShimmer = false;
        let cartRes = res;
        this.logincartProduct = res;
        localStorage.setItem("isSwitch", "false");
        if (res["meta"]["status"]) {
          this._dataLayerService.itemcheckoutGTM(res["data"]["addtoCart"]);
          let userCartLength = res["data"]["addtoCart"]
            ? res["data"]["addtoCart"].length
            : 0;
          this.cartLengthService.cartLengthUpdateFunction(userCartLength);
          this.weightLimit = res["otherWtSum"];
          this.weightLimitFlower = res["flowerWtSum"];
          let percentage = (this.weightLimit / this.CartBarLimit) * 100;
          let percentageFlower =
            (this.weightLimitFlower / this.CartBarLimitFlower) * 100;
          if (res["minimumCartValuebyCity"]) {
            this.CompareWithSubTotal =
              res["minimumCartValuebyCity"]?.currentStoreMinCartValue;
            this.CartSubTotal = Number(res["subTotal"]);
          }
          if (this.weightLimit) {
            this.progressbarWidth = String(percentage.toFixed(0)) + "%";
          } else {
            this.progressbarWidth = String(percentage.toFixed(0) + "%");
          }
          if (this.weightLimitFlower) {
            this.progressbarWidthFlower =
              String(percentageFlower.toFixed(0)) + "%";
          } else {
            this.progressbarWidthFlower = String(
              percentageFlower.toFixed(0) + "%",
            );
          }

          localStorage.setItem("cartLimit", this.weightLimit);
          localStorage.setItem("cartLimitFlower", this.weightLimitFlower);
          this.getStaffPicsList();
          this.showLoginStaffPick = true;
          if (
            res["data"] &&
            res["data"]["addtoCart"] &&
            res["data"]["addtoCart"].length === 0
          ) {
            localStorage.setItem("loggedInCart", String(this.cartLength));
            this.commonService.updateCartProduct(0);
            this.cartSum = "$" + 0;
            this.cartMessageError = "";
            this.userSrv.updateCartMessage("");
          } else {
            this.cartLength = res["data"]["addtoCart"].length;

            localStorage.setItem("loggedInCart", String(this.cartLength));

            this.carts = res["data"]["addtoCart"];
            this.commonService.updateCartProduct(
              res["data"]["addtoCart"].length,
            );
            this.cartSum = "$" + Number(res.grandTotal).toFixed(2);
          }
        } else {
          this.weightLimit = 0;
          this.weightLimitFlower = 0;
          localStorage.setItem("cartLimit", this.weightLimit);
          localStorage.setItem("cartLimitFlower", this.weightLimitFlower);
          localStorage.setItem("loggedInCart", String(this.cartLength));
          this.commonService.updateCartProduct(0);
          this.cartSum = "$" + 0;
          this.cartMessageError = "";
          this.userSrv.updateCartMessage("");
        }
        return cartRes;
      });
  }

  validateCCcard(month, year) {
    let ptDatePattern = "^((0[1-9])|(1[0-2]))/([0-9]{4})$";
    let datevalue = month + "/" + year;
    if (datevalue.match(ptDatePattern)) return true;
    else {
      let todayDate = new Date();

      let controlDate = new Date(year, month - 1, 1, 23, 59, 59);
      let dateCompare = new Date(
        todayDate.getFullYear(),
        todayDate.getMonth(),
        1,
        0,
        0,
        0,
      );
      if (dateCompare > controlDate) {
        return true;
      }
    }

    return false;
  }

  getCardNumberControl(): AbstractControl | null {
    return this.paymentForm && this.paymentForm.get("cardnumber");
  }

  addToCartvar(productDetails, boolean) {
    const addressStatus = localStorage.getItem("addressStatus");
    if (addressStatus === null || addressStatus === "false") {
      $("#SearchLocation").modal("show");
    } else if (!this.auth) {
      this.addOfflineProductInCart(productDetails);
    } else {
      let limit = localStorage.getItem("cartLimit");
      if (this.varqtyvalue <= 1 && !boolean) {
        return;
      }
      this.loaderSrv.startLoader("", "");
      let obj = {
        inventoryId: productDetails.CatalogItemId,
        selectQuantity: 1,
        storeId: Number(localStorage.getItem("localStoreId")),
        orderType: this.getOrderType(),
        productId: productDetails.CatalogItemId,
        wtSum: limit,
        qtyIncrease: true,
      };

      if (!boolean) {
        obj["qtyIncrease"] = false;
      }
      this.commonService.addProductInCartnew(obj).subscribe((res) => {
        if (res["meta"]["status"]) {
          let userCartLength = res["data"]["addtoCart"]
            ? res["data"]["addtoCart"].length
            : 0;
          this.cartLengthService.cartLengthUpdateFunction(userCartLength);
          this.updateCartObservableFunction(res);
          this._dataLayerService.addToCartGTM(res["data"]["addtoCart"]);

          if (boolean) {
            this.varqtyvalue = this.varqtyvalue + 1;
          } else {
            this.varqtyvalue = this.varqtyvalue - 1;
          }
          this.loaderSrv.changeStateandStopLoader(
            "success",
            "Added to Cart",
            1000,
          );
        } else {
          this.errorMsg = res["meta"]["msg"];
          if (
            this.errorMsg ===
            "Store must be unique ! Please try again with same store"
          ) {
            $("#exampleModal").modal("show");
            this.loaderSrv.stopLoader();
          } else {
            this.loaderSrv.changeStateandStopLoader(
              "error",
              res["meta"]["msg"],
              3000,
            );
          }
        }
      });
    }
  }

  getImageSize(productImg) {
    return productImg;
  }

  getThreeLetterDay(day) {
    var res = day.substring(0, 3);
    return res;
  }

  showDivOnPage(timeSlot, message) {
    let router = this.router.url;
    if (router.match("upload-id")) {
      return false;
    } else {
      if (timeSlot !== "") {
        return false;
      } else if (message !== "") {
        return true;
      }
    }
  }

  guestForm_lastNameError = "";
  guestForm_firstNameError = "";
  guestForm_emailError = "";
  phoneNumberErrorHandler(event, ifpartfor) {
    if (ifpartfor == "cvvguest") {
      let cvv = this.CreditCardForm_guest?.value?.cvv_guest;
      if (cvv?.length < 3) {
        return false;
      } else {
        return true;
      }
    }
    if (ifpartfor == "pscode") {
      let cvv = this.CreditCardForm_guest?.value?.pcode_guest;
      if (cvv?.length < 6) {
        return false;
      } else {
        return true;
      }
    }
  }

  onKeyUp(x, val2) {
    // appending the updated value to the variable

    x.target.value = x.target.value.toLocaleUpperCase();
  }

  mynewStoreHoursFormat(timeslot1) {    
    var newtimeslot = timeslot1.split("-");
    var newStartHour = moment(newtimeslot[0], ["HH:mm"]).format("h:mm A");
    var newEndHour = moment(newtimeslot[1], ["HH:mm"]).format("h:mm A");
    return newStartHour + " to " + newEndHour;
  }

  guestToken;
  GuestName;
  GuestMobile;
  GuestEmail;
  Instrucstion;
  checkoutpart2subtotal;
  guestemailId;
  guestlastName;
  guestFirstName;
  guestmobile;
  guestsignuptype;
  guestpostalcode;
  guestcardNumber;
  guestPostalCode;
  guestExpiryDate;
  guestCvv;
  selected_date_text; // --date
  checkoutpart2discount;
  GETaCTUALpRICE;
  mobileVarify() {
    $("#mobileVerifymodel").modal("show");
  }
  OKOTP() {
    $("#mobileVerifymodel").modal("hide");
  }
  verificationFormSubmission(value) {}

  keytab(event) {
    let PreElement = event.srcElement.previousElementSibling; // get the sibling element
    let element = event.srcElement.nextElementSibling; // get the sibling element
    let numPad: boolean = false;
    for (let i = 0; i < 10; i++) {
      if (event.code == `Numpad${i}` || event.code == `Digit${i}`) {
        numPad = true;
        break;
      }
    }
    if (event.code == `Backspace`) {
      if (PreElement == null)
        // check if its null
        return;
      else PreElement.focus();
    } else if (numPad) {
      if (element == null)
        // check if its null
        return;
      else element.focus(); // focus if not null
    }
  }
  validStreetAddress = "";
  validCityAddress = "";

  getDeliveryChangesForGuest(): number {
    if (
      this.freeDelivery?.isdelivery &&
      this.optionType === "DELIVERY" &&
      this.guest_subtotal < this.freeDelivery?.freeDeliveryAmount
    ) {
      return this.freeDelivery.deliveryCharges;
    } else {
      return 0;
    }
  }

  getDeliveryChangesForUser() {
    if (
      this.freeDelivery?.isdelivery &&
      this.optionType == "DELIVERY" &&
      Number(this.logincartProduct?.subTotal) <
        this.freeDelivery?.freeDeliveryAmount
    ) {
      return this.freeDelivery?.deliveryCharges;
    } else {
      return 0;
    }
  }
  calculateTotals(grandTotal: number) {
    return (
      Number(grandTotal || 0) + Number(this.driver_tip ? this.driver_tip : 0)
    );
  }

  calculateTotal(grandTotal: number, deliveryCharge: number): number {
    const subtotal = this.getSubTotal(this.logincartProduct?.subTotal);
    if (
      this.optionType === "DELIVERY" &&
      this.freeDelivery?.isdelivery &&
      subtotal < this.freeDelivery?.freeDeliveryAmount
    ) {
      return (
        Number(grandTotal) +
        Number(deliveryCharge) +
        Number(this.driver_tip ? this.driver_tip : 0)
      );
    }
    // Otherwise (free delivery or pickup), just return grand total
    return Number(grandTotal) + Number(this.driver_tip ? this.driver_tip : 0);
  }
  guestDiscountLabels: any[] = [];
  guestDiscount: any = 0;
  discountLabelNewArray: any;
  guestGrandTotal: any = 0;
  addGuest() {
    this.submitted = true;
    if (this.guestAddForm.invalid) {
      return;
    }

    if (this.count != 1) {
      this.count = 0;
      return;
    }
    if (
      !this.auth &&
      this.guestAddForm?.value?.mobile?.toString()?.length < 10
    ) {
      this.count = 0;
      return;
    }
    if (this.optionType == "DELIVERY") {
      if (this.addressString == "" || this.addressString == undefined) {
        this.count = 0;
        return;
      }
    }

    var str = this.CreditCardForm_guest.value.street_address_guest;
    var str2 = this.CreditCardForm_guest.value.city_address_guest;
    this.validStreetAddress = str?.replace(/(^[\s]+|[\s]+$)/g, "");
    this.validCityAddress = str2?.replace(/(^[\s]+|[\s]+$)/g, "");
    this.choosenTimeSlot = this.timiSelected;
    let offlineProduct1 = JSON.parse(localStorage.getItem("cartProduct"));
    let productArray2 = offlineProduct1["product"];
    this.addressString = localStorage.getItem("addressString");
    this.addressString = localStorage.getItem("addressString");
    let Array = [];
    productArray2.forEach((elm) => {
      Array.push({
        orderType: this.getOrderType(),
        selectQuantity: elm?.quantity,
        productId: elm?.productId,
      });
    });

    this.GuestName =
      this.guestAddForm.value.firstName +
      " " +
      this.guestAddForm.value.lastName;
    this.GuestMobile = this.guestAddForm.value.mobile;
    this.GuestEmail = this.guestAddForm.value.email;

    let objtosend = {
      firstName: this.guestAddForm.value.firstName,
      deliveryCharges: this.getDeliveryChangesForGuest(),
      lastName: this.guestAddForm.value.lastName,
      emailId: this.guestAddForm.value.email,
      signuptype: "web",
      mobile: this.guestAddForm.value.mobile,
      postalcode: this.guestAddForm.value.postalCode,
      deviceToken:
        "863e02f0ace476e0c565b7e98e8bc280e8b23ca1b7c8a566592df1987b4cb81d",
      cartProduct: Array,
      storeId: localStorage.getItem("localStoreId"),
      password: "123456",
    };

    ((this.guestFirstName = this.guestAddForm.value.firstName),
      (this.guestlastName = this.guestAddForm.value.lastName),
      (this.guestemailId = this.guestAddForm.value.email),
      (this.guestmobile = this.guestAddForm.value.mobile),
      (this.guestcardNumber =
        this.CreditCardForm_guest.value.cardnumber_guest));
    this.guestExpiryDate =
      this.CreditCardForm_guest.value.expiryMonth_guest +
      "/" +
      this.CreditCardForm_guest.value.expiryYear_guest;
    this.guestCvv = this.CreditCardForm_guest.value.cvv_guest;
    this.guestPostalCode = this.CreditCardForm_guest.value.pcode_guest;

    let optionType: any = localStorage.getItem("optionType");

    if (optionType != "DELIVERY") {
      delete objtosend["deliveryCharges"];
    }

    $("#loadMe").modal("show");
    this.commonService.addGuestuser(objtosend).subscribe((res) => {
      this.count = 0;
      if (!res["meta"]["status"]) {
        this.loaderSrv.startLoader("", "");
        this.loaderSrv.changeStateandStopLoader(
          "error",
          res["meta"]["msg"],
          2000,
        );
        $("#loadMe").modal("hide");
      } else {
        this.offlineCartProduct = res["meta"]["data"][0]["addtoCart"];
        // FIX: Properly handle discount labels from API response
        this.discountLabelNewArray = res["meta"]["discountLabelNewArray"];

        // Store discount labels for display in summary
        if (res["meta"]["discountLabel"]) {
          this.guestDiscountLabels = res["meta"]["discountLabel"];
          this.guestDiscount = res["meta"]["discount"];
        }
        this.guestGrandTotal = res["meta"]["grandTotal"];

        this.calulateGuestTax(res["userData"]["userId"]);

        if (optionType != "DELIVERY") {
          this.step = 3;
        }
        if (optionType == "PICKUP") {
          this.getPaymentMethodOption("", "cash");
          this.radiobtnonForCash_guest = true;
        }
        if (optionType == "CURBSIDE") {
          this.getPaymentMethodOption("", "cash");
          this.radiobtnonForCash_guest = true;
        }
        if (optionType == "DELIVERY") {
          this.selectedPaymentMethod_guest = "creditcard";
          this.radiobtnonForCash_guest = true;
          this.getPaymentMethodOption("", "cash");
          $("#loadMe").modal("hide");
        } else {
          $("#loadMe").modal("hide");
        }
        this.submitted = false;
        let token = res["userToken"];
        localStorage.setItem("guestKey", token);
        this.guestToken = token;
        localStorage.setItem("guestToken", this.guestToken);
        let userData: any = res["userData"];
        this.CreditCardForm_guest.patchValue({
          firstname_guest: userData?.firstName,
          lastname_guest: userData?.lastName,
          email_guest: userData?.emailId,
          phone_guest: userData?.mobile,
          country_address_guest: "US",
        });
        this.guestModeOn = true;
        this.Instrucstion = $("#deliveryInstruction").val();
      }
    });
  }
  guestSubmitted: boolean = false;

  GuestAdd() {
    if (
      this.selectedPaymentMethod_guest == "creditcard" &&
      !this.radiobtnonForCash_guest
    ) {
      this.guestCardSubmitted = true;
      if (this.CreditCardForm_guest.invalid) {
        return;
      }

      var str = this.CreditCardForm_guest.value.street_address_guest;
      var str2 = this.CreditCardForm_guest.value.city_address_guest;
      this.validStreetAddress = str?.replace(/(^[\s]+|[\s]+$)/g, "");
      this.validCityAddress = str2?.replace(/(^[\s]+|[\s]+$)/g, "");
      let offlineProduct1 = JSON.parse(localStorage.getItem("cartProduct"));
      let productArray2 = offlineProduct1["product"];
      this.addressString = localStorage.getItem("addressString");
      this.addressString = localStorage.getItem("addressString");
      let Array = [];
      productArray2.forEach((elm) => {
        Array.push({
          orderType: this.getOrderType(),
          selectQuantity: elm.quantity,
          productId: elm.productId,
        });
      });
      this.GuestName =
        this.guestAddForm.value.firstName +
        " " +
        this.guestAddForm.value.lastName;
      this.GuestMobile = this.guestAddForm.value.mobile;
      this.GuestEmail = this.guestAddForm.value.email;

      this.step = 3;
    } else {
      this.step = 3;
    }
  }

  backFrom_Guest_credit() {
    this.step = 2;
    this.count = 0;
    this.guestForm_firstNameError = "";
    this.guestForm_lastNameError = "";
    this.guestForm_emailError = "";
    this.choosenTimeSlot = "";
    this.guestModeOn = false; //hide guest
    this.showCreditCardForEntry_guest = false;
    this.showTimeSlotDiv = true; // show time slot
  }
  backFrom_Guest_t() {
    this.step = 2;
    this.count = 0;
    this.guestModeOn = true;
    this.guestdilveryShow = localStorage.getItem("isPickUpOrder");

    if (this.guestdilveryShow == "false") {
      this.selectedPaymentMethod_guest = "creditcard";
    }

    let isStore = localStorage.getItem("isCash");
    if (isStore == "true") {
      this.radiobtnonForCash_guest = true;
      this.showCreditCardForEntry_guest = false;
    }

    this.guestToken = null;
    this.showPlaceOrderDiv = false;
    window.scrollTo(0, 0);
  }

  tip_percentage;
  calucalte_driverTip(percentage) {
    $("#custom_tip").val(""); // reset custom tip input

    if (!this.auth) {
      let guestGrandTotal = Number(this.guestTexDetails?.subTotal);
      this.tip_percentage = percentage;
      let guesttip = (guestGrandTotal * percentage) / 100;
      this.driver_tip = guesttip.toFixed(2);
      this.show_tip_in_cart = true;
    } else {
      this.tip_percentage = percentage;
      let grandTotal = Number(this.logincartProduct?.subTotal);
      let tip = (grandTotal * percentage) / 100;
      this.driver_tip = tip.toFixed(2);
      this.show_tip_in_cart = true;
    }
  }

  value = 0.05;
  newtotal;
  a1;
  /* tipSelect: boolean = false; */
  show_tip_in_cart: boolean = false;
  applytip(boolean) {
    if (boolean) {
      let totalValue = 0;
      this.driver_tip = this.customTipvalue;
      if (!this.auth) {
        totalValue = Number(this.guestTexDetails?.subTotal);
        this.tip_percentage = (this.driver_tip / totalValue) * 100;
      } else {
        totalValue = Number(this.logincartProduct?.subTotal);
        this.tip_percentage = (this.driver_tip / totalValue) * 100;
      }
      if (this.customTipvalue < totalValue) {
        this.show_tip_in_cart = true;
      }
    } else {
      this.driver_tip = 0;
      this.customTipvalue = 0;
      this.show_tip_in_cart = false;
      this.tip_percentage = 0;
      $("input[name=tips]").attr("checked", false);
      $("input[name=tips]").prop("checked", false);
      $("input[name=tips]").attr("disabled", false);
      $("#custom_tip").val("");
    }
  }

  addressChange() {
    $("#shoppingCart").modal("hide");
  }

  selectedTimeSlotDiv;
  showSlotAccordingToDate(date, day, index, milliSecond, dateIndex) {
    this.currentDay = day;
    this.selectedMillSecond = milliSecond;
    this.gettingTimeSlot();
    $("input[type=radio][name=radio1]").prop("checked", false);
    var splitTime = this.est24Hours.split(":");
    dateIndex == 0
      ? (this.currentHourMin = Number(splitTime[0]) * 60 + Number(splitTime[1]))
      : (this.currentHourMin = 1);
    this.selectedDate = date;
    this.selectedTimeSlotDiv = index;
    this.choosenTimeSlot = "";
    this.selectedDeliveryTimeSlot = "";
    this.selectedTimeSlotDifference = "";
    this.timeSlotErr = "";
  }
  onChange(selectval) {
    console.log(selectval,'selectvalselectvalselectval',this.selectedDeliveryTimeSlot);
    
    let item: any = this.timeSlotArray.find((itm) => itm.value == selectval);
    this.selectedDeliveryTimeSlot = selectval;
    console.log(this.selectedDeliveryTimeSlot,'this.selectedDeliveryTimeSlotthis.selectedDeliveryTimeSlot');
    
    this.selectedTimeSlotDifference = "";
    this.slotColor = item?.color;
  }

  showPlaceOrderDiv;
  timeSlotErr: any = "";
  radiobtnonForCash_auth;
  showTip_in_guestCase: Boolean = false;
  managePlaceOrderDiv(val) {
    if (this.addressString !== "") {
      if (val == 1) {
        let offlineProduct1 = JSON.parse(localStorage.getItem("cartProduct"));
        let productArray2 = offlineProduct1["product"];
        this._dataLayerService.guestitemcheckoutGTM(productArray2);
        this.getAddress();
        this.choosenTimeSlot = this.timiSelected;
        if (
          this.choosenTimeSlot == undefined ||
          this.choosenTimeSlot == "" ||
          this.choosenTimeSlot == null
        ) {
          setTimeout(() => {
            this.timeSlotErr = "";
          }, 5000);
          this.count = 1;
          return (this.timeSlotErr = "Time Slot is required ");
        }
        if (!this.auth) {
          this.GuestMode(val);
        }
      } else {
        this.isPickup = localStorage.getItem("isPickUpOrder");
        this.getAddress();
        if (this.auth) {
          if (this.isPickup == "true") {
            this.showTip_in_guestCase = false;
          }
        }
        this.choosenTimeSlot = this.timiSelected;
        if (
          this.choosenTimeSlot == undefined ||
          this.choosenTimeSlot == "" ||
          this.choosenTimeSlot == null
        ) {
          setTimeout(() => {
            this.timeSlotErr = "";
          }, 5000);
          this.count = 1;
          return (this.timeSlotErr = "Time Slot is required ");
        }
        this.Instrucstion = $("#deliveryInstruction").val();
        if (val == 0) {
          this.radiobtnonForCash_auth = true; //check radio btn
          this.showPlaceOrderDiv = true;
          this.showTimeSlotDiv = false;
          window.scrollTo(0, 0);
          this.guestdilveryShow = localStorage.getItem("isPickUpOrder"); //
          if (this.guestdilveryShow == "false") {
            this.radiobtnonForCash_auth = true; //
            this.selectedPaymentMethod_auth = "cash";
          } else {
          }
        }
      }
    } else {
      if (!this.auth) {
        this.GuestMode(val);
      }
    }
  }

  backFrom_checkout_auth() {
    $("#loadMe").modal("show");
    this.step = 1;
    this.count = 0;
    this.loginModeOn = false;
    this.showLoginStaffPick = true;
    this.showTimeSlotDiv = false;
    this.choosenTimeSlot = "";
    localStorage.getItem("addressLatitude");
    localStorage.getItem("addressLongitude");
    this.getCartProduct();
    setTimeout(() => {
      $("#loadMe").modal("hide");
    }, 2000);
    window.scrollTo(0, 0);
  }

  backFrom_checkout_guest() {
    this.step = 1;
    this.count = 0;
    this.showTimeSlotDiv = false;
    this.showLoginStaffPick = true;
    this.choosenTimeSlot = "";

    // Reset guest-specific states
    this.guestModeOn = false;
    this.guestToken = null;
    this.showPlaceOrderDiv = false;

    // Clear any guest form data
    this.guestAddForm.reset();
    this.submitted = false;

    // Reload the original cart
    this.getOfflineProduct();

    window.scrollTo(0, 0);
  }
  redirectToDetailPage(slug: string) {
    document.getElementById("close-cart").click();
    this.router.navigateByUrl(`/product-details/${slug}`);
  }

  closeCart() {
    this.hidecart();
  }

  //TIME CONVERTER FUNCTION FOR SENDING TO API TO IN GUEST ORDER PLACE
  newSelectedDeliveryTimeSlot;
  newChoosenTimeSlot;
  timeConverter(selectedDeliveryTimeSlot, choosenTimeSlot) {
    if (selectedDeliveryTimeSlot && choosenTimeSlot) {
      let st = selectedDeliveryTimeSlot?.split("-");
      let ct = choosenTimeSlot?.split("-");
      let open = st[0]?.toString();
      let close = st[1]?.toString();
      let ctOpen = ct[0]?.toString();
      let ctClose = ct[1]?.toString();
      this.newSelectedTime(open, close, ctOpen, ctClose);
    }
  }
  newSelectedTime(open, close, ctOpen, ctClose) {
    let a = moment(open, ["HH.mm"]).format("ha");
    let b = moment(close, ["HH.mm"]).format("ha");
    let c = moment(ctOpen, ["HH.mm"]).format("h");
    let d = moment(ctClose, ["HH.mm"]).format("h");
    let t1 = open.split(":");
    let t2 = close.split(":");
    this.newSelectedDeliveryTimeSlot = a.concat(" to ", b);
    this.newChoosenTimeSlot = t1[0].concat("to", t2[0]);
  }

  backToCreditCard() {
    if (this.optionType == "DELIVERY") {
      this.guestdilveryShow = "false";
    }
    this.radiobtnonForCash_auth = false;
    this.canShowThankyoupage = false;
    this.CreditCardForm_login.patchValue({
      selectCard: true,
    });
    this.step = 3;
  }

  guestOrderPlacingError;
  guestOrderDetails;

  guestOrderPlace() {
    if (!this.radiobtnonForCash_guest) {
      this.selectedPaymentMethod_guest = "creditcard";
    } else {
      this.selectedPaymentMethod_guest = "cash";
    }

    let optionType = localStorage.getItem("optionType");
    let objs;
    if (optionType == "DELIVERY") {
      objs = {
        CustomerId: this.userId,
        AddressTypeId: 2,
        AttentionTo: this.userName,
        CountryCode: this.addressCountry,
        Default: false,
        DoNotContact: true,
        Email: "",
        Locality: this.addressLocality,
        Notes: this.addressRoute,
        Phone: "",
        PostalCode: this.addressPostalCode,
        PostOfficeBoxNumber: this.addressRoute,
        StateCode: this.addressAdministrationLevel,
        StreetAddress1: this.addressFormattedAddress,
        StreetAddress2: this.addressSubLocality,
        currentLat: localStorage.getItem("currentLat"),
        currentLong: localStorage.getItem("currentLong"),
        formattedAddress: this.addressFormattedAddress,
      };
    } else {
      let storeInfo: any = localStorage.getItem("storeInfo");
      storeInfo = JSON.parse(storeInfo);

      objs = {
        CustomerId: this.userId,
        AddressTypeId: 2,
        AttentionTo: this.userName,
        CountryCode: "US",
        Default: false,
        DoNotContact: true,
        Email: "",
        Locality: storeInfo["Address"]?.City,
        Notes: this.addressRoute,
        Phone: "",
        PostalCode: storeInfo["Address"]?.Zip,
        PostOfficeBoxNumber: this.addressRoute,
        StateCode: storeInfo["Address"]?.StateCode,
        StreetAddress1: storeInfo["Address"]?.AddressLine2,
        StreetAddress2: storeInfo["Address"]?.AddressLine2,
        currentLat: storeInfo["location"]?.coordinates[1],
        currentLong: storeInfo["location"]?.coordinates[0],
        formattedAddress: storeInfo["Address"]?.AddressLine2,
      };
    }

    let objtosend: any = {
      address: objs,
      // paymentMethod: this.selectedPaymentMethod_guest,
      paymentMethod: this.GetPaymentMethod(),
      deliveryCharges: this.getDeliveryChangesForGuest(),
      deviceType: "web",
      specialInstruction: this.deliveryInstruction,
      currentLong: objs?.currentLong,
      currentLat: objs?.currentLat,
      deliveryTime: this.timiSelected,
      deliveryTimeSlot: this.mynewStoreHoursFormat(this.timiSelected),
      token: this.guestToken,
      orderDate: this.selectedMillSecond,
      slotType: this.newChoosenTimeSlot,
      timeSlotDifference: this.selectedTimeSlotDifference,
      slotColor: this.getSlotColor(),
      dispatcher: "true",
      orderType: this.getOrderType(),
      storeName: localStorage.getItem("localStoreName"),
      storeId: Number(localStorage.getItem("localStoreId")),
      discountLabelNewArray: this.guestTexDetails["discountLabelNewArray"],
      discountLabel: this.guestTexDetails["discountLabel"],
      discount: this.guestTexDetails["discount"],
    };

    //
    if (this.show_tip_in_cart) {
      objtosend["tipValue"] = Number(this.driver_tip);
      objtosend["tipPercentage"] = String(this.tip_percentage.toFixed(2));
    }

    if (this.selectedPaymentMethod_guest == "creditcard") {
      objtosend["cardNumber"] = this.guestcardNumber;
      objtosend["cardType"] = this.GetCardTypeName(this.guestcardNumber);

      objtosend["cvv"] = this.guestCvv;
      objtosend["expiration"] = this.guestExpiryDate;
      objtosend["postalCodeCreditCard"] = this.guestPostalCode;
      let objBillAddress = {
        street: this.validStreetAddress,
        apartment: this.CreditCardForm_guest.value.apartment,
        city: this.validCityAddress,
        state: this.CreditCardForm_guest?.value.state_address_guest,
        country: this.CreditCardForm_guest?.value.country_address_guest
          ? this.CreditCardForm_guest?.value.country_address_guest
          : "US",
        zip: this.CreditCardForm_guest?.value?.pcode_guest,
        firstName: this.CreditCardForm_guest?.value?.firstname_guest,
        lastName: this.CreditCardForm_guest?.value?.lastname_guest,
        email: this.CreditCardForm_guest?.value?.email_guest,
        phone: this.CreditCardForm_guest?.value?.phone_guest,
      };
      objtosend["billingAddress"] = objBillAddress;
    }
    $("#loadMe").modal("show");
    setTimeout(() => {
      this.commonService.guestOrderPlace(objtosend).subscribe(
        (res) => {
          if (res["meta"]["status"]) {
            this.commonService.emittedCartValue.next(true); // header function for cart count
            this.offlineCartProduct = res["data"]["productDetails"];
            this.step = 4;
            $("#loadMe").modal("hide");
            this.guestdilveryShow = "true";
            this.showTip_in_guestCase = false;
            this.canShowThankyoupage = true;
            this.guestOrderDetails = res["data"];
            this.billingAddress = res["data"].billingAddress;
            this.completeOrderData = res["data"];
            this.cartLengthService.cartLengthUpdateFunction(0);
            this.orderDetail = res["data"];
            this._dataLayerService.OrderPlace(res["data"]);
            if (this.selectedPaymentMethod_auth == "creditcard") {
              this.canShowPaymentStatus = true;
              this.PaymentApiCalled("guest");
            } else {
              let datas = {
                room: "highlife4adda783-2521-4d8e-9330-e3a6679cc2f4",
                data: `New order received`,
                orderType: this.getOrderType(),
                orderDisplayId: res["data"]?.orderDisplayId,
              };
              this.socketService.emit("order message", datas);
              this.thankyoupageType = "Order Successful!";
              if (res["data"]?.orderType == "Delivery") {
                this.thankyoupageType2 =
                  "Thanks for placing your order! A member of our team will be in touch shortly to schedule delivery and payment.";
                this.step = 4;
                localStorage.removeItem("cartProduct");
                localStorage.removeItem("timiSelected");
                this.thankyoupageType = "Order Successful!";
                this.commonService.emittedCartValue.next(true); // header function for cart count
                this.cartLengthService.cartLengthUpdateFunction(0);
              } else {
                let datas = {
                  room: "highlife4adda783-2521-4d8e-9330-e3a6679cc2f4",
                  data: `New order received`,
                  orderType: this.getOrderType(),
                  orderDisplayId: res["data"]?.orderDisplayId,
                };
                this.socketService.emit("order message", datas);
                localStorage.removeItem("cartProduct");
                localStorage.removeItem("timiSelected");
                this.thankyoupageType = "Order Successful!";
                this.thankyoupageType2 =
                  "Thank you for your Purchase, your order has been received! ";
                this.canShowPaymentStatus = false;
                this.pamyentStatus = "Completed";
                this.commonService.emittedCartValue.next(true); // header function for cart count
                this.cartLengthService.cartLengthUpdateFunction(0);
              }
              this.canShowPaymentStatus = false;
            }
            // if (this.selectedPaymentMethod_guest == "creditcard") {
            //   this.canShowPaymentStatus = true;
            //   this.PaymentApiCalled("guest");
            // } else {
            //   let datas = {
            //     room:'highlife4adda783-2521-4d8e-9330-e3a6679cc2f4',
            //     data:`New order received`,
            //     orderType:this.getOrderType(),
            //     orderDisplayId:res['data']?.orderDisplayId
            //   }
            //   this.socketService.emit('order message', datas);
            //   localStorage.removeItem("cartProduct");
            //   localStorage.removeItem("timiSelected");
            //   this.thankyoupageType = "Order Successful!";
            //   this.thankyoupageType2 = "Thank you for your Purchase, your order has been received! ";
            //   this.canShowPaymentStatus = false;
            //   this.pamyentStatus = "Completed";
            // }
          } else {
            // let datas = {
            //   room:'highlife4adda783-2521-4d8e-9330-e3a6679cc2f4',
            //   data:`New order received`,
            //   orderType:this.orderType
            // }
            // this.socketService.emit('order message', datas);

            $("#loadMe").modal("hide");
            this.loaderSrv.startLoader("", "");
            this.loaderSrv.changeStateandStopLoader(
              "error",
              res["meta"]["msg"],
              4000,
            );
          }
        },
        (error) => {
          $("#loadMe").modal("hide");
        },
      );
    }, 300);
  }
  paymentStreet;
  paymentCity;
  paymentState;
  paymentCountry;
  billingAddress;
  completeOrderData;
  usercvvError;
  userCreditcardError;
  userExpiryrError;
  orderDetail;
  canShowThankyoupage: Boolean = false;
  canShowPaymentStatus: Boolean = false;
  thankyoupageType: String = "Order Summary";
  thankyoupageType2: String = "";
  validStreetLoginAddress = "";
  validctyLoginAddress = "";

  getSlotColor() {
    let val = this.timeSlotArray.filter(
      (color) => color?.value == this.timiSelected,
    );
    return val[0]?.color;
  }

  GetPaymentMethod() {
    let value: any;
    if (localStorage.getItem("optionType") == "PICKUP") {
      return (value = "cash");
    } else if (this.siteDada?.paymentGatewayInfo == "Aeropay") {
      return (value = "ACH");
    } else if (
      localStorage.getItem("optionType") == "DELIVERY" &&
      this.radiobtnonForCash_auth
    ) {
      return (value = "ACH");
    } else if (
      localStorage.getItem("optionType") == "DELIVERY" &&
      this.radiobtnonForCash_guest
    ) {
      return (value = "ACH");
    } else {
      return (value = "creditcard");
    }
  }

  EmailFormatLast4Digit(item: string) {
    if (!item.includes("@")) {
      return; // Return if the email format is incorrect
    }

    const [localPart, domain] = item.split("@");

    // For short local parts, adjust the slicing logic
    if (localPart.length <= 4) {
      // Mask all characters except the first character
      const start = localPart[0];
      const end = localPart.slice(-1);
      const middleMasked = "*".repeat(localPart.length - 2);
      return `${start}${middleMasked}${end}@${domain}`;
    }

    // Proceed with original logic if the local part is longer than 4 characters
    const startRemoved = localPart.slice(0, 2); // First 2 characters
    const endRemoved = localPart.slice(-2); // Last 2 characters
    const modifiedStr = localPart.slice(2, -2); // Remaining part after removal
    const starPattern = "*".repeat(modifiedStr.length); // Asterisks for remaining characters

    return startRemoved + starPattern + endRemoved + "@" + domain;
  }

  verfiyUserForAeroPay() {
    this.submitted = true;

    if (this.optionType != "PICKUP") {
      if (this.aeropayForm.invalid && !this.arpay) {
        return;
      }
    }
    let aeroPayForm: any;
    if (this.arpay) {
      aeroPayForm = {
        email: this.bankAccounts?.email,
        last_name: this.bankAccounts?.lastName,
        phone_number: this.bankAccounts?.phone.split("+1")[1],
        first_name: this.bankAccounts?.firstName,
      };
    } else {
      aeroPayForm = this.aeropayForm.value;
    }
    let payLoad: any = {
      email: aeroPayForm?.email,
      last_name: aeroPayForm?.last_name,
      phone_number: aeroPayForm?.phone_number,
      first_name: aeroPayForm?.first_name,
    };
    this.loaderSrv.startLoader("Please Wait!", "");
    this.commonService.CheckUser(payLoad).subscribe((res: any) => {
      this.loaderSrv.stopLoader();
      if (res["meta"]["status"]) {
        Swal.fire({
          title: `You've previously used AeroPay to pay another business. Please verify your identity by entering the pin sent to your email ${this.EmailFormatLast4Digit(
            res["data"]?.email,
          )}`,
          input: "text",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: "Submit",
          showLoaderOnConfirm: true,
          preConfirm: async (login) => {
            if (login) {
              let payload = {
                userId: res["data"]?.userId,
                mfaCode: login,
                phone_number: res["data"]?.phone,
              };
              $("#loadMe").modal("show");

              this.commonService.verfiyMfaCode(payload).subscribe((itm) => {
                $("#loadMe").modal("hide");
                if (itm["meta"]["status"]) {
                  if (itm["aeropayUserBankInfo"]?.bankAccounts?.length < 1) {
                    Swal.fire({
                      html: '<h3 style="color: red;font-size:font-size: 2.2rem !important;">Connect your bank account to initiate a transaction.</h3> <h5 style="color: black !important;">Do you want to connect your bank account with Aeropay?</h5>',
                      icon: "error",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Yes Connect !",
                    }).then((result) => {
                      if (result.value) {
                        this.appStateSvc.setState({
                          aeroPayUser: this.aeropayForm.value,
                        });
                        $("#shoppingCart").modal("hide");

                        this.router.navigateByUrl(
                          "/dashboard/payment-setup?mfa=true",
                        );
                      }
                    });
                  } else {
                    this.PlaceOrderforLoginUser(
                      itm["aeropayUserBankInfo"],
                      login,
                    );
                  }
                } else {
                  this.loaderSrv.startLoader("", "");
                  this.loaderSrv.changeStateandStopLoader(
                    "error",
                    itm["meta"]["msg"],
                    3500,
                  );
                }
              });
            } else {
              Swal.showValidationMessage(`Access Denied !`);
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {});
      } else {
        this.loaderSrv.startLoader("", "");
        this.loaderSrv.changeStateandStopLoader(
          "error",
          res["meta"]["msg"],
          3500,
        );
      }
    });
  }

  orderDates() {
    // let weekday = new Date().toLocaleString("en-us", { weekday: "long" });
    let a = this.storeDetails["StoreHours"][this.currentDay];
    if (a.Close.Minute == "0") {
      a.Close.Minute = "00";
    }
    var StoreCloseTime: any = a.Close.Hour + ":" + a.Close.Minute;
    if (StoreCloseTime == "0:00") {
      StoreCloseTime = "24:00";
    }
    var currentDate: any = new Date();
    var currentHour = currentDate.getHours();
    var currentMinuts = currentDate.getMinutes();
    let totalSeconds1 = parseInt(currentHour * 3600 + currentMinuts * 60 + "0");
    let totalSeconds2 = parseInt(
      StoreCloseTime.split(":")[0] * 3600 +
        StoreCloseTime.split(":")[1] * 60 +
        "0",
    );
    let hours = new Date().getHours();
    const ampm = hours >= 12 ? "pm" : "am";
    if (totalSeconds1 > totalSeconds2 && ampm == "pm") {
      currentDate.setDate(currentDate.getDate() + 1);
      this.loaderSrv.startLoader("", "");
      this.loaderSrv.changeStateandStopLoader(
        "success",
        "Your order will be delivered tomorrow.",
        3000,
      );
    } else {
      currentDate = new Date();
    }
    return this.selectedMillSecond;
  }

  PlaceOrderforLoginUser(resData?, mfaCode?) {
    this.submitted = true;
    this.count += this.count;
    this.pickUpStatus = localStorage.getItem("isPickUpOrder");
    var str = this.CreditCardForm_login.value.street_address;
    var str2 = this.CreditCardForm_login.value.city_address;
    this.validStreetLoginAddress = str.replace(/(^[\s]+|[\s]+$)/g, "");
    this.validctyLoginAddress = str2.replace(/(^[\s]+|[\s]+$)/g, "");
    let objs;
    let deliveryAddress: any = localStorage.getItem("SavedAddress");
    deliveryAddress = JSON.parse(deliveryAddress);
    if (localStorage.getItem("optionType") == "DELIVERY") {
      objs = {
        CustomerId: this.userId,
        AddressTypeId: 2,
        AttentionTo: deliveryAddress?.AttentionTo,
        CountryCode: "US",
        Default: false,
        DoNotContact: true,
        Email: "",
        Locality: this.addressLocality,
        Notes: this.addressRoute,
        Phone: "",
        PostalCode: deliveryAddress?.PostalCode,
        PostOfficeBoxNumber: this.addressRoute,
        StateCode: deliveryAddress?.StateCode,
        StreetAddress1: deliveryAddress?.formattedAddress,
        StreetAddress2: deliveryAddress?.formattedAddress,
        currentLat: localStorage.getItem("currentLat"),
        currentLong: localStorage.getItem("currentLong"),
        formattedAddress: deliveryAddress?.formattedAddress,
      };
    } else {
      let pickupAddress: any = localStorage.getItem("storeInfo");
      pickupAddress = JSON.parse(pickupAddress);
      objs = {
        CustomerId: this.userId,
        AddressTypeId: 2,
        AttentionTo: this.userName,
        CountryCode: "US",
        Default: false,
        DoNotContact: true,
        Email: "",
        Locality: pickupAddress?.Address?.City,
        Notes: this.addressRoute,
        Phone: "",
        PostalCode: pickupAddress?.Address?.Zip,
        PostOfficeBoxNumber: this.addressRoute,
        StateCode: pickupAddress?.Address?.StateCode,
        StreetAddress1: pickupAddress?.Address?.street,
        StreetAddress2: pickupAddress?.Address?.AddressLine2,
        currentLat: pickupAddress?.location?.coordinates[1],
        currentLong: pickupAddress?.location?.coordinates[0],
        formattedAddress: pickupAddress?.Address?.AddressLine2,
      };
    }

    let obj: any = {
      deviceType: "web",
      address: objs,
      specialInstruction: this.deliveryInstruction,
      paymentMethod: this.GetPaymentMethod(),
      currentLong: objs?.currentLong,
      currentLat: objs?.currentLat,
      orderDate: this.orderDates(),
      timeSlotDifference: this.selectedTimeSlotDifference,
      slotType: this.newChoosenTimeSlot,
      deliveryTimeSlot: this.mynewStoreHoursFormat(
        localStorage.getItem("timiSelected")
          ? localStorage.getItem("timiSelected")
          : this.timiSelected,
      ),
      deliveryTime: localStorage.getItem("timiSelected")
        ? localStorage.getItem("timiSelected")
        : this.timiSelected,
      slotColor: this.getSlotColor(),
      token: localStorage.getItem("covatoken"),
      dispatcher: localStorage.getItem("dispatcher") === "true" ? true : false,
      orderType: this.getOrderType(),
      deliveryCharges: this.getDeliveryChangesForUser(),
      createdAt: Number(new Date()),
      orderFrom: "web",
      regionId: Number(localStorage.getItem("localStoreId")),
      regionName: localStorage.getItem("localStoreName")
        ? localStorage.getItem("localStoreName")
        : "",
      storeId: Number(localStorage.getItem("localStoreId")),
      storeName: localStorage.getItem("localStoreName"),
      discountLabel: this.logincartProduct["discountLabel"],
      discountLabelNewArray: this.logincartProduct["discountLabelNewArray"],
      discount: this.logincartProduct["discount"],

      // mfaCode:mfaCode,
      // phone_number:resData?.phone,
      // aeropayUserId:resData?.userId,
      // bankAccountId:resData?.bankAccounts[0]?.bankAccountId,
    };
    // this.logincartProduct
    if (this.show_tip_in_cart) {
      obj["tipValue"] = Number(this.driver_tip);
      obj["tipPercentage"] = String(this.tip_percentage.toFixed(2));
    }
    if (this.selectedPaymentMethod_auth == "creditcard") {
      obj["cardNumber"] = this.CreditCardForm_login.value.cardnumber_login;
      obj["cvv"] = this.CreditCardForm_login.value.cvv_login;
      obj["expiration"] =
        this.CreditCardForm_login.value.expiryMonth_login +
        "/" +
        this.CreditCardForm_login.value.expiryYear_login;
      obj["zip"] = this.CreditCardForm_login.value.pcode_login;
      let objBillAddress = {
        street: this.validStreetLoginAddress,
        city: this.validctyLoginAddress,
        state: this.CreditCardForm_login.value.state_address,
        country: this.CreditCardForm_login.value.country_address,
        zip: this.CreditCardForm_login.value.pcode_login,
        firstName: this.CreditCardForm_login.value.firstname_login,
        lastName: this.CreditCardForm_login.value.lastname_login,
        email: this.CreditCardForm_login.value.email_login,
        phone: this.CreditCardForm_login.value.phone_login,
        apartment: this.CreditCardForm_login.value.apartment,
      };
      obj["billingAddress"] = objBillAddress;
    }
    if (this.count > 2) {
      return;
    }        $("#loadMe").modal("show");
    this.commonService.placeOrderAPI(obj).subscribe(
      (res) => {
        if (res["meta"]["status"]) {
          $("#addressOptionModal").modal("hide");
          this.count = 1;
          this.submitted = false;
          this.commonService.emittedCartValue.next(true); // header function for cart count

          if (this.optionType != "PICKUP") {
            this.aeropayForm.reset();
            this.appStateSvc.setState({
              aeroPayUser: "",
            });
          }
          localStorage.removeItem("timiSelected");
          $("#loadMe").modal("hide");
          this.billingAddress = res["data"].billingAddress;
          this.completeOrderData = res["data"];
          this.cartLengthService.cartLengthUpdateFunction(0);
          this.canShowThankyoupage = true;
          this.guestdilveryShow = "ture";
          this.orderDetail = res["data"];
          this.commonService.updateCartProduct(0);
          localStorage.setItem("shippmentAggrement", "0");
          localStorage.removeItem("createdAt");
          localStorage.removeItem("timeSlot");
          localStorage.removeItem("newChoosenTimeSlot");
          localStorage.removeItem("deliveryTimeSlot");
          localStorage.removeItem("timiSelected");
          localStorage.removeItem("slotColor");
          this._dataLayerService.OrderPlace(res["data"]);
          if (this.selectedPaymentMethod_auth == "creditcard") {
            this.canShowPaymentStatus = true;
            this.PaymentApiCalled("user");
          } else {
            this.thankyoupageType = "Order Successful!";
            if (res["data"]?.orderType == "Delivery") {
              this.thankyoupageType2 =
                "Thanks for placing your order! A member of our team will be in touch shortly to schedule delivery and payment.";
              this.step = 4;
              let datas = {
                room: "highlife4adda783-2521-4d8e-9330-e3a6679cc2f4",
                data: `New order received`,
                orderType: this.getOrderType(),
                orderDisplayId: res["data"]?.orderDisplayId,
              };
              this.socketService.emit("order message", datas);
            } else {
              this.thankyoupageType2 =
                "Thank you for your Purchase, your order has been received! ";
              let datas = {
                room: "highlife4adda783-2521-4d8e-9330-e3a6679cc2f4",
                data: `New order received`,
                orderType: this.getOrderType(),
                orderDisplayId: res["data"]?.orderDisplayId,
              };
              this.socketService.emit("order message", datas);
              this.step = 4;
            }
            this.canShowPaymentStatus = false;
          }
        } else {
          $("#loadMe").modal("hide");
          this.count = 1;
          this.loaderSrv.startLoader("", "");
          this.loaderSrv.changeStateandStopLoader(
            "error",
            res["meta"]["msg"],
            4000,
          );
          if (res["meta"]["msg"] == "No product in your cart.") {
            window.location.reload();
          }
        }
      },
      (err) => {
        this.count = 1;
      },
    );
  }

  pad(n, width, z?) {
    z = z || "0";
    n = n + "";
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  PaymentApiCalled(userTpye) {
    var cardNumber = "";
    var cardMonth = "";
    var cardYear = "";
    var cardCVV = "";
    if (userTpye == "guest") {
      cardNumber = this.CreditCardForm_guest.value.cardnumber_guest;
      cardCVV = this.CreditCardForm_guest.value.cvv_guest;
      cardYear = this.CreditCardForm_guest.value.expiryYear_guest;
      cardMonth = this.CreditCardForm_guest.value.expiryMonth_guest;
    } else {
      cardNumber = this.CreditCardForm_login.value.cardnumber_login;
      cardCVV = this.CreditCardForm_login.value.cvv_login;
      cardYear = this.CreditCardForm_login.value.expiryYear_login;
      cardMonth = this.CreditCardForm_login.value.expiryMonth_login;
    }
    let isDefault: boolean = false;
    if (this.CreditCardForm_login.value.saveCard_user) {
      isDefault = true;
    }
    let obj = {
      storeAccountNum: Number(localStorage.getItem("storeAccountNum")),
      authorization: localStorage.getItem("authorization"),
      orderDisplayId: this.completeOrderData.orderDisplayId,
      amount: Number(this.completeOrderData.grandTotal.toFixed(2)),
      cardNum: cardNumber,
      cardType: this.GetCardTypeName(cardNumber),
      month: Number(cardMonth),
      year: Number(cardYear),
      saveCard_user: this.CreditCardForm_login.value.saveCard_user,
      default: isDefault,
      cvv: cardCVV,
      street: this.billingAddress.street,
      city: this.billingAddress.city,
      state: this.billingAddress.state,
      country: this.billingAddress.country,
      zip: this.billingAddress.zip,
      firstName: this.billingAddress.firstName,
      lastName: this.billingAddress.lastName,
      email: this.billingAddress.email,
      phone: this.billingAddress.phone,
    };

    $("#loadMe").modal("show");
    this.commonService.callPaymentProcessApi(obj).subscribe(
      (res) => {
        this.cvvLoginUser = "";

        this.orderCompleteDetails = res["data"];
        if (res["meta"]["status"] == true) {
          $("#loadMe").modal("hide");
          let datas = {
            room: "highlife4adda783-2521-4d8e-9330-e3a6679cc2f4",
            data: `New order received`,
            orderType: this.getOrderType(),
            orderDisplayId: res["data"]?.orderDisplayId,
          };
          this.socketService.emit("order message", datas);
          if (userTpye == "guest") {
            localStorage.removeItem("cartProduct");
            localStorage.removeItem("timiSelected");
          }
          this.pamyentStatus = "Completed";
          this.paymentMessage = "Your payment is successfully completed";
          this.thankyoupageType = "Order Successful!";
          this.thankyoupageType2 =
            "Thank you for your Purchase, your order has been received! ";
          this.updateCovaPaymentStatus(this.orderCompleteDetails);
        } else {
          $("#loadMe").modal("hide");
          this.pamyentStatus = "Failed";
          this.paymentMessage = res["meta"]["msg"];
          this.thankyoupageType = "Order Failed";
          this.thankyoupageType2 =
            "Your order request can't be processed because we could not verify your card";
        }
      },
      (error) => {
        // alert("not working")
      },
    );
    this.guestAddForm.reset();
  }

  updateCovaPaymentStatus(data) {
    $("#loadMe").modal("hide");
    let obj = {
      orderData: data,
    };
    let apiStatus;
    this.commonService.updateCovaPaymentStatus(obj).subscribe((res) => {
      apiStatus = res;
    });
  }

  showToolTip() {
    document.getElementById("tooltip_new").style.visibility = "visible";
    setTimeout(() => {
      document.getElementById("tooltip_new").style.visibility = "hidden";
    }, 3000);
  }

  showToolTipFlowe() {
    document.getElementById("tooltip_newFlower").style.visibility = "visible";
    setTimeout(() => {
      document.getElementById("tooltip_newFlower").style.visibility = "hidden";
    }, 3000);
  }

  showToolTip1() {
    document.getElementById("tooltip_new1").style.visibility = "visible";
    setTimeout(() => {
      document.getElementById("tooltip_new1").style.visibility = "hidden";
    }, 3000);
  }

  showToolTips() {
    document.getElementById("tooltip_news").style.visibility = "visible";
    setTimeout(() => {
      document.getElementById("tooltip_news").style.visibility = "hidden";
    }, 3000);
  }

  hidecart() {
    if (this.auth) {
      $("#shoppingCart").modal("hide");
      this.canShowThankyoupage = false;
      this.showPlaceOrderDiv = false;
      this.showLoginStaffPick = true;
      this.loginModeOn = false;
    } else {
      $("#shoppingCart").modal("hide");
      this.canShowThankyoupage = false;
      this.showPlaceOrderDiv = false;
      this.loginModeOn = false;
      this.showTimeSlotDiv = false;
      // for guest
      this.cartLength = 0;
      this.guestProgressbarWidth = "0%";
      localStorage.removeItem("cartProduct");
      this.addressString = "";
      localStorage.removeItem("addressString");
      this.getOfflineProduct();
    }
    this.router.navigateByUrl("/").then(() => {
      location.reload();
    });
  }

  backFrom_Proceed_checkout_auths() {
    this.step = 3;
    this.count = 0;
    this.showPlaceOrderDiv = false;
    this.showTimeSlotDiv = true;
    this.choosenTimeSlot = "";
    this.guestdilveryShow = localStorage.getItem("isPickUpOrder");
  }

  backFrom_Proceed_checkout_auth() {
    this.step = 2;
    this.count = 0;
    this.showPlaceOrderDiv = false;
    this.showTimeSlotDiv = true;
    this.choosenTimeSlot = "";
    this.guestdilveryShow = localStorage.getItem("isPickUpOrder");
    window.scrollTo(0, 0);
  }

  customTipvalue;
  invalidTip: Boolean = false;
  driverCustomTip(value) {
    this.customTipvalue = Number(value.target.value);
    let totalValue = 0;
    this.driver_tip = 0;
    if (!this.auth) {
      totalValue = Number(this.guestTexDetails?.subTotal);
    } else {
      totalValue = Number(this.logincartProduct?.subTotal);
    }
    if (this.customTipvalue < totalValue) {
      this.invalidTip = false;
      if (this.customTipvalue) {
        $("input[name=tips]").attr("disabled", true);
        $("input[name=tips]").prop("checked", false);
        if (!this.auth) {
          this.tip_percentage = this.customTipvalue / Number(totalValue);
        } else {
          this.tip_percentage =
            this.customTipvalue / Number(this.logincartProduct?.subTotal);
        }
        this.show_tip_in_cart = false;
      } else {
        $("input[name=tips]").attr("disabled", false);
        $("input[name=tips]").attr("checked", false);
        $("input[name=tips]").prop("checked", false);
        this.show_tip_in_cart = false;
      }
    } else {
      $("input[name=tips]").attr("disabled", false);
      $("input[name=tips]").attr("checked", false);
      $("input[name=tips]").prop("checked", false);
      this.show_tip_in_cart = false;
      this.invalidTip = true;
      $("#custom_tip").val("");
    }
  }

  addSelectedVariance(productDetails) {
    if (!this.auth) {
      let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
      let array = currentcartProd?.product.filter(
        (product) => product?.productId == productDetails?.CatalogItemId,
      );
      if (array?.length == 0) {
        this.addToCart(productDetails);
      } else {
        array?.forEach((itm: any, i) => {
          if (itm?.productId == productDetails?.CatalogItemId) {
            if (itm?.quantity < productDetails?.Quantity) {
              this.addToCart(productDetails);
            } else {
              this.loaderSrv.startLoader("", "");
              this.loaderSrv.changeStateandStopLoader(
                "error",
                `Maximum quantity of this product is ${productDetails?.Quantity}`,
                2000,
              );
            }
          }
        });
        if (currentcartProd == undefined) {
          this.addToCart(productDetails);
        }
      }
    } else {
      this.addToCart(productDetails);
    }
  }

  offlineWeightCheck(productDetails, value, list) {
    let flowerLimit: any = localStorage.getItem("CartBarLimitFlower");
    let otherLimit: any = localStorage.getItem("CartBarLimit");
    let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
    if (
      currentcartProd &&
      currentcartProd["product"] &&
      currentcartProd["product"]?.length
    ) {
      if (
        this._bs.fetchCategoryId(list?.category) == 2543 &&
        this._bs.fetchCategoryId(list?.category) != 2542
      ) {
        let flowerProducts: any = currentcartProd["product"]?.filter(
          (itm) => itm?.categoryId == 2543,
        );
        let floweWeight: any = 0;
        flowerProducts?.forEach((element) => {
          floweWeight += element?.equivalentToVal * element?.quantity;
        });
        if (
          Number(floweWeight) +
            Number(productDetails?.productDetails?.EquivalentToVal) >
          flowerLimit
        ) {
          $("#cartLimitModalFlower").modal("show");
          setTimeout(() => {
            $("#cartLimitModalFlower").modal("hide");
          }, 1500);
          return;
        } else {
          this.addOfflineProductInCart(productDetails, value, list);
        }
      }

      if (
        this._bs.fetchCategoryId(list?.category) != 2543 &&
        this._bs.fetchCategoryId(list?.category) != 2542
      ) {
        let otherProducts: any = currentcartProd["product"]?.filter(
          (itm) => itm?.categoryId != 2543,
        );
        let otherWeight: any = 0;
        otherProducts?.forEach((element) => {
          otherWeight += element?.equivalentToVal * element?.quantity;
        });
        if (
          Number(otherWeight) +
            Number(productDetails?.productDetails?.EquivalentToVal) >
          otherLimit
        ) {
          $("#cartLimitModal").modal("show");
          setTimeout(() => {
            $("#cartLimitModal").modal("hide");
          }, 1500);
          return;
        } else {
          this.addOfflineProductInCart(productDetails, value, list);
        }
      }
    } else {
      this.addOfflineProductInCart(productDetails, value, list);
    }
  }

  imageDetails;
  letNewArray: Array<any> = [];
  qty: any;

  addOfflineProductInCart(productDetails, boolean?, list?) {
    $("#loadMe").modal("show");
    this.loaderSrv.startLoader("", "");

    let currentcartWeight = 0;
    let currentProductWeight: any;
    let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
    if (currentcartProd && currentcartProd["product"]) {
      currentProductWeight = productDetails?.productDetails?.EquivalentToVal
        ? productDetails?.productDetails?.EquivalentToVal
        : 0;
      currentcartProd["product"].forEach((cartPd) => {
        currentcartWeight = currentcartWeight + cartPd.weight * cartPd.quantity;
      });
    }
    let totalWeight = Number(currentcartWeight) + Number(currentProductWeight);
    this.CartBarLimit = localStorage.getItem("CartBarLimit");
    // if (totalWeight > this.CartBarLimit) {
    //   $("#loadMe").modal("hide");
    //   this.loaderSrv.stopLoader();
    //   $("#cartLimitModal").modal("show");
    //   return;
    // }

    let image;
    let productName = "";
    this.imageDetails = productDetails["productDetails"].Assets;
    if (this.imageDetails !== undefined && this.imageDetails.length > 0) {
      if (
        this.imageDetails[0].Uri !== null &&
        this.imageDetails[0].Uri !== ""
      ) {
        image = this.imageDetails[0].Uri;
      } else {
        image = this.defaultUrl;
      }
    } else {
      image = this.defaultUrl;
    }
    if (list != undefined && list !== null) {
      this.imageDetails = list["productDetails"].Assets;
      productName = productDetails.productDetails.ProductName;
      if (this.imageDetails !== undefined && this.imageDetails.length > 0) {
        if (
          this.imageDetails[0].Uri !== null &&
          this.imageDetails[0].Uri !== ""
        ) {
          image = this.imageDetails[0].Uri;
        } else {
          image = this.defaultUrl;
        }
      } else {
        image = this.defaultUrl;
      }
    } else {
      productName = productDetails["productDetails"].ProductName;
    }
    if (boolean) {
      this.qty = this.varqtyvalue++;
    }
    var hasMatch = false;
    let array = JSON.parse(localStorage.getItem("cartProduct"));
    this.letNewArray.push(array);
    let productArray = [];
    let productArray1 = [];
    let cartProductArrayWithStore;
    let cartProductArrayWithStore1;

    //---------------------- condition store change   cart become null
    if (localStorage.getItem("cartProduct") === null || array.length === 0) {
      this.varqtyvalue = 1; //first time variance add

      cartProductArrayWithStore = {
        storeId: localStorage.getItem("localStoreId"),
      };
      cartProductArrayWithStore1 = {
        storeId: localStorage.getItem("localStoreId"),
      };
      productArray1.push({
        productId: productDetails.CatalogItemId,
        selectQuantity: this.qtyValue,
        orderType: this.getOrderType(),
      });
      productArray.push({
        productId: productDetails.CatalogItemId,
        productType: "simple",
        myPrice: productDetails?.myPrice,
        inventoryType: productDetails.inventoryType,
        storeId: localStorage.getItem("localStoreId"),
        quantity: 1,
        weight: productDetails.productDetails.EquivalentToVal
          ? productDetails.productDetails.EquivalentToVal
          : 0,
        actualQuantity: productDetails?.Quantity,
        productName: productName,
        productImg: image ? image : this.defaultUrl,
        price: productDetails.price,
        buyPrice: productDetails.Msrp,
        purchaseStatus: "purchase",
        categoryId: this._bs.fetchCategoryId(list?.category),
        productDisplayId: productDetails.CatalogItemId,
      });
      cartProductArrayWithStore1["cartProduct"] = productArray1;
      localStorage.setItem(
        "cartProduct",
        JSON.stringify(cartProductArrayWithStore1),
      );
      this.letNewArray = productArray;
      this.letNewArray.forEach((e) => {});
      cartProductArrayWithStore["product"] = productArray;
      localStorage.setItem(
        "cartProduct",
        JSON.stringify(cartProductArrayWithStore),
      );
      this.loaderSrv.changeStateandStopLoader("success", "Added to Cart", 2000);
      this.commonService.emittedCartValue.next(true);
      this.commonService.go_invokeCartResetFunction_forguest(); // rest guest cart  screen to to 1
    } else {
      let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
      let currentcartWeight = 0;
      let currentProductWeight = productDetails.productDetails.EquivalentToVal
        ? productDetails.productDetails.EquivalentToVal
        : 0;
      currentcartProd["product"].forEach((cartPd) => {
        currentcartWeight = currentcartWeight + cartPd.weight * cartPd.quantity;
      });
      let totalWeight =
        Number(currentcartWeight) + Number(currentProductWeight);
      this.CartBarLimit = localStorage.getItem("CartBarLimit");
      // if (totalWeight > this.CartBarLimit) {

      //   $('#cartLimitModal').modal('show');
      //   $("#loadMe").modal("hide");
      //   this.loaderSrv.stopLoader()
      //   // return alert('CART LIMIT EXCEDD')1
      //   return
      // }
      let productArrayData = JSON.parse(localStorage.getItem("cartProduct"));
      let productArrayData1 = JSON.parse(localStorage.getItem("cartProduct"));
      let arrayData = [];
      let arrayData1 = [];
      productArray = productArrayData["product"];
      productArray1 = productArrayData1["cartProduct"];
      if (productArray1 == undefined) {
        productArray1 = [];
      }
      if (
        productArrayData["storeId"] === localStorage.getItem("localStoreId")
      ) {
        for (var i = 0; i < productArray.length; i++) {
          if (productArray[i].productId === productDetails.CatalogItemId) {
            this.varqtyvalue = 1; //first time variance add
            let removedata = productArray.splice(i, 1);
            productArray1.push({
              productId: productDetails.CatalogItemId,
              selectQuantity: productArrayData["product"].quantity,
              orderType: this.getOrderType(),
            });
            productArray.push({
              productId: productDetails.CatalogItemId,
              productType: "simple",
              myPrice: productDetails?.myPrice,
              inventoryType: productDetails.inventoryType,
              storeId: localStorage.getItem("localStoreId"),
              quantity: Number(removedata[0]["quantity"]) + 1,
              weight: productDetails.productDetails.EquivalentToVal
                ? productDetails.productDetails.EquivalentToVal
                : 0,
              productName: productName,
              productImg: image,
              price: productDetails.price,
              actualQuantity: productDetails?.Quantity,
              buyPrice: productDetails.Msrp,
              purchaseStatus: "purchase",
              productDisplayId: productDetails.CatalogItemId,
              categoryId: this._bs.fetchCategoryId(list?.category),
            });
            arrayData1["cartProduct"] = productArray1;
            arrayData["product"] = productArray;
            localStorage.setItem(
              "cartProduct",
              JSON.stringify(productArrayData1),
            );
            localStorage.setItem(
              "cartProduct",
              JSON.stringify(productArrayData),
            );
            $("#loadMe").modal("hide");
            this.loaderSrv.changeStateandStopLoader(
              "success",
              "Added to Cart",
              3000,
            );
            this.commonService.emittedCartValue.next(true);
            this.commonService.go_invokeCartResetFunction_forguest(); // rest guest cart  screen to to 1
            let categoryName;
            hasMatch = true;
            break;
          }
        }
      } else {
        $("#loadMe").modal("hide");
        this.loaderSrv.changeStateandStopLoader(
          "error",
          "Clear cart first then add product",
          3000,
        );
      }
      if (!hasMatch) {
        this.varqtyvalue = 1; //first time variance add

        productArray1.push({
          productId: productDetails.CatalogItemId,
          selectQuantity: this.qtyValue,
          orderType: this.getOrderType(),
        });
        productArray.push({
          productId: productDetails.CatalogItemId,

          productType: "simple",
          myPrice: productDetails?.myPrice,
          inventoryType: productDetails.inventoryType,
          storeId: localStorage.getItem("localStoreId"),
          quantity: this.qtyValue,
          weight: productDetails.productDetails.EquivalentToVal
            ? productDetails.productDetails.EquivalentToVal
            : 0,
          productName: productName,
          productImg: image,
          price: productDetails.price,
          buyPrice: productDetails.Msrp,
          categoryId: this._bs.fetchCategoryId(list?.category),
          actualQuantity: productDetails?.Quantity,
          purchaseStatus: "purchase",
          productDisplayId: productDetails.CatalogItemId,
        });
        cartProductArrayWithStore1 = {
          storeId: localStorage.getItem("localStoreId"),
          cartProduct: productArray1,
        };
        let cartProductArrayWithStore = {
          storeId: localStorage.getItem("localStoreId"),
          product: productArray,
        };
        localStorage.setItem(
          "cartProduct",
          JSON.stringify(cartProductArrayWithStore1),
        );
        localStorage.setItem(
          "cartProduct",
          JSON.stringify(cartProductArrayWithStore),
        );
        $("#loadMe").modal("hide");
        this.loaderSrv.changeStateandStopLoader(
          "success",
          "Added to Cart",
          2000,
        );
        this.commonService.emittedCartValue.next(true);
        this.commonService.go_invokeCartResetFunction_forguest(); // rest guest cart  screen to to 1
      }
    }
    this.letNewArray = productArray;
    this._dataLayerService.addToCartGTMGuest(this.letNewArray);

    this.commonService.updateCartProduct(productArray.length);
  }
  //add var. or not

  offlineWeightIncrease(
    productId,
    optionId,
    optionTypeId,
    productType,
    event,
    boolean,
    weight,
    myPrice,
    productDetails,
  ) {
    let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
    if (
      currentcartProd &&
      currentcartProd["product"] &&
      currentcartProd["product"]?.length
    ) {
      let flowerLimit: any = localStorage.getItem("CartBarLimitFlower");
      let otherLimit: any = localStorage.getItem("CartBarLimit");
      let weight: any = 0;
      let array: any = [];
      let array1: any = [];
      if (flowerLimit > 0) {
        currentcartProd["product"].map((itm) => {
          if (itm?.categoryId == 2543 && productDetails?.categoryId == 2543) {
            array.push(itm);
          } else if (itm?.categoryId != 2543) {
            array1.push(itm);
          }
        });
        const arrayUniqueByKey = [
          ...new Map(array.map((item) => [item["productId"], item])).values(),
        ];
        arrayUniqueByKey?.map((item: any, i) => {
          if (item?.equivalentToVal == undefined) {
            item["equivalentToVal"] = item?.weight;
          }
          if (item?.categoryId == 2543) {
            weight = item?.equivalentToVal * item?.quantity + weight;
            if (
              weight + productDetails?.weight <= Number(flowerLimit) &&
              arrayUniqueByKey?.length - 1 == i
            ) {
              this.increaseDecreaseOfflineProduct(
                productId,
                optionId,
                optionTypeId,
                productType,
                event,
                boolean,
                weight,
                myPrice,
              );
            } else if (
              weight + productDetails?.weight > Number(flowerLimit) &&
              arrayUniqueByKey?.length - 1 == i
            ) {
              $("#cartLimitModalFlower").modal("show");
              return;
            }
          }
        });
        if (array?.length == 0 && productDetails?.categoryId == 2543) {
          this.increaseDecreaseOfflineProduct(
            productId,
            optionId,
            optionTypeId,
            productType,
            event,
            boolean,
            weight,
            myPrice,
          );
          return;
        }
        array1?.map((item: any, i) => {
          if (productDetails?.categoryId != 2543 && item?.categoryId != 2543) {
            weight = item?.weight * item?.quantity + weight;
            if (
              weight + productDetails?.weight <= Number(otherLimit) &&
              array1?.length - 1 == i
            ) {
              this.increaseDecreaseOfflineProduct(
                productId,
                optionId,
                optionTypeId,
                productType,
                event,
                boolean,
                weight,
                myPrice,
              );
            } else if (
              weight + productDetails?.weight > Number(otherLimit) &&
              array1?.length - 1 == i
            ) {
              $("#cartLimitModal").modal("show");
              setTimeout(() => {
                // $("#cartLimitModal").modal("hide");
              }, 2000);
              return;
            }
          }
        });
        if (array1?.length == 0 && productDetails?.categoryId != 2543) {
          this.increaseDecreaseOfflineProduct(
            productId,
            optionId,
            optionTypeId,
            productType,
            event,
            boolean,
            weight,
            myPrice,
          );
        }
      } else {
        weight = 0;
        currentcartProd["product"]?.map((item: any, i) => {
          weight = item?.weight * item?.quantity + weight;
        });

        if (weight + productDetails?.weight <= Number(otherLimit)) {
          this.increaseDecreaseOfflineProduct(
            productId,
            optionId,
            optionTypeId,
            productType,
            event,
            boolean,
            weight,
            myPrice,
          );
        } else if (weight + productDetails?.weight > Number(otherLimit)) {
          $("#cartLimitModal").modal("show");
          setTimeout(() => {
            $("#cartLimitModal").modal("hide");
          }, 2000);
          return;
        }
        if (currentcartProd["product"]?.length == 0) {
          this.increaseDecreaseOfflineProduct(
            productId,
            optionId,
            optionTypeId,
            productType,
            event,
            boolean,
            weight,
            myPrice,
          );
        }
      }
    } else {
      this.increaseDecreaseOfflineProduct(
        productId,
        optionId,
        optionTypeId,
        productType,
        event,
        boolean,
        weight,
        myPrice,
      );
    }
  }

  increaseDecreaseOfflineProduct(
    productId,
    optionId,
    optionTypeId,
    productType,
    event,
    boolean,
    weight,
    myPrice,
  ) {
    if (event == 10 && boolean && event < 0) {
      return;
    }
    let currentcartProd: any = JSON.parse(localStorage.getItem("cartProduct"));
    currentcartProd?.product?.forEach((itm: any) => {
      if (itm?.productId == productId && boolean) {
        if (itm?.quantity < itm?.actualQuantity) {
          let array = JSON.parse(localStorage.getItem("cartProduct"));
          let currentcartWeight = 0;
          currentcartProd["product"].forEach((cartPd) => {
            currentcartWeight =
              currentcartWeight + cartPd.weight * cartPd.quantity;
          });

          let newArray = [];
          let productArray = {};
          productArray["storeId"] = array["storeId"];
          productArray["discountIn"] = array["discountIn"];
          productArray["discountOn"] = array["discountOn"];
          productArray["discountPercent"] = array["discountPercent"];
          productArray[""];

          if (boolean) {
            event = Number(event) + 1;
          } else {
            event = Number(event) - 1;
          }

          array["product"].map((x, i) => {
            if (
              x.productId === productId &&
              x.optionId === optionId &&
              x.optionTypeId === optionTypeId
            ) {
              newArray.push({
                buyPrice: x.buyPrice,
                categoryName: x.categoryName,
                inventoryType: x.inventoryType,
                equivalentToVal: x?.equivalentToVal,
                productslug: x?.productslug,
                optionId: x.optionId,
                optionTypeId: x.optionTypeId,
                price: x.price,
                actualQuantity: x?.actualQuantity,
                myPrice: x.myPrice,
                productId: x.productId,
                productImg: x.productImg,
                productName: x.productName,
                productTitle: x.productTitle,
                productType: x.productType,
                purchaseStatus: x.purchaseStatus,
                quantity: event,
                storeId: x.storeId,
                weight: x.weight,
                categoryId: x?.categoryId,
                selectQuantity: event,
              });
            } else {
              newArray.push(x);
            }
          });

          productArray["product"] = newArray;
          localStorage.setItem("cartProduct", JSON.stringify(productArray));
          this.ngOnInit();
        } else {
          this.loaderSrv.startLoader("", "");
          this.loaderSrv.changeStateandStopLoader(
            "error",
            `Maximum quantity of this product is ${event}`,
            2000,
          );
        }
      }

      if (itm?.productId == productId && !boolean) {
        let array = JSON.parse(localStorage.getItem("cartProduct"));
        let currentcartWeight = 0;
        currentcartProd["product"].forEach((cartPd) => {
          currentcartWeight =
            currentcartWeight + cartPd.weight * cartPd.quantity;
        });

        let newArray = [];
        let productArray = {};
        productArray["storeId"] = array["storeId"];
        productArray["discountIn"] = array["discountIn"];
        productArray["discountOn"] = array["discountOn"];
        productArray["discountPercent"] = array["discountPercent"];
        productArray[""];

        if (boolean) {
          event = Number(event) + 1;
        } else {
          event = Number(event) - 1;
        }

        array["product"].map((x, i) => {
          if (
            x.productId === productId &&
            x.optionId === optionId &&
            x.optionTypeId === optionTypeId
          ) {
            newArray.push({
              buyPrice: x.buyPrice,
              categoryName: x.categoryName,
              inventoryType: x.inventoryType,
              optionId: x.optionId,
              productslug: x?.productslug,
              optionTypeId: x.optionTypeId,
              price: x.price,
              equivalentToVal: x?.equivalentToVal,
              actualQuantity: x?.actualQuantity,
              myPrice: x.myPrice,
              productId: x.productId,
              productImg: x.productImg,
              productName: x.productName,
              productTitle: x.productTitle,
              productType: x.productType,
              purchaseStatus: x.purchaseStatus,
              quantity: event,
              storeId: x.storeId,
              weight: x.weight,
              categoryId: x?.categoryId,
              // selectQuantity: event,
              selectQuantity: x?.selectQuantity,
            });
          } else {
            newArray.push(x);
          }
        });

        productArray["product"] = newArray;
        localStorage.setItem("cartProduct", JSON.stringify(productArray));
        this.ngOnInit();
      }
    });
  }

  GetCardType(number: any) {
    if (number.length < 15) {
      this.cardImage = "";
      return;
    }
    let value: any;
    var re = new RegExp("^4");
    if (number.match(re) != null) {
      value = "Visa";
      return (this.cardImage = "assets/images/visa.png");
    }
    if (
      /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
        number,
      )
    ) {
      value = "Mastercard";
      return (this.cardImage = "assets/images/mastercard.png");
    }
    re = new RegExp("^3[47]");
    if (number.match(re) != null) {
      value = "AMEX";
      return (this.cardImage = "assets/images/amex.png");
    }
    re = new RegExp(
      "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)",
    );
    if (number.match(re) != null) {
      value = "Discover";
      return (this.cardImage = "assets/images/doscover.png");
    }
    re = new RegExp("^36");
    if (number.match(re) != null) {
      value = "Diners";
      return (this.cardImage = "assets/images/diners.png");
    }
    re = new RegExp("^30[0-5]");
    if (number.match(re) != null) {
      value = "Diners - Carte Blanche";
      return (this.cardImage = "assets/images/diners.png");
    }
    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number.match(re) != null) {
      value = "JCB";
      return (this.cardImage = "assets/images/jcb.png");
    }

    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number.match(re) != null) {
      value = "Visa Electron";
      return (this.cardImage = "assets/images/visa.png");
    }
    if (number == "") {
      return (this.cardImage = "");
    }
  }

  removeProductFromOfflineCart(productId, productDetails) {
    let offlineData = [];
    offlineData = JSON.parse(localStorage.getItem("cartProduct"));
    offlineData["product"].map((x, i) => {
      if (productDetails.productType === "simple") {
        if (x.productId === productId) {
          offlineData["product"].splice(i, 1);
          localStorage.setItem("cartProduct", JSON.stringify(offlineData));
          this.cartLength = offlineData["product"].length;
          if (!this.cartLength) {
            this.cartLengthService.cartLengthUpdateFunction(0);
            this.ngOnInit();
          } else {
            this.cartLengthService.cartLengthUpdateFunction(this.cartLength);
            this.ngOnInit();
          }
        }
      } else {
        if (x.bundlerProductId === productId) {
          offlineData["product"].splice(i, 1);
          localStorage.setItem("cartProduct", JSON.stringify(offlineData));
          this.cartLength = offlineData["product"].length;
          this.commonService.emittedCartValue.next(true);
          this.commonService.updateCartProduct(offlineData["product"].length);
        }
      }
    });
  }
  guestTax$: Observable<any>;
  calulateGuestTax(userId) {
    this.addressString = localStorage.getItem("addressString");
    let Array = [];
    this.offlineCartProduct.forEach((elm) => {
      Array.push({
        myPrice: elm.myPrice ? elm.myPrice : elm.price,
        price: elm.price,
        selectQuantity: elm.selectQuantity,
        CatalogItemId: elm.inventoryId,
        storeId: localStorage.getItem("localStoreId"),
        userId: userId,
        isfree: elm.isfree,
      });
    });

    let obj = {
      userId: userId,
      cartData: Array,
    };

    this.commonService.getGuestTax(obj).subscribe((res) => {
      this.guestTax = res["tax"];
      this.guestTexDetails = res;
      // Ensure discount labels are included
      if (this.guestDiscountLabels && this.guestDiscountLabels.length > 0) {
        this.guestTexDetails.discountLabel = this.guestDiscountLabels;
        this.guestTexDetails.discount = this.guestDiscount;
      }
      this.guestTexDetails["grandTotal"] = this.guestGrandTotal;
      //
      this.guestModeOn = true;
      this.selectedPaymentMethod_guest = "cash";
      this.guestdilveryShow = localStorage.getItem("isPickUpOrder");

      if (this.guestdilveryShow == "false") {
        if (localStorage.getItem("optionType") == "PICKUP") {
          this.radiobtnonForCash_guest = true;
        } else {
          this.radiobtnonForCash_guest = true;
        }
        this.selectedPaymentMethod_guest = "creditcard";
      }

      this.guestSubTotal = res["subTotal"];
      if (Number(res["subTotal"]) >= Number(res["mySubTotal"])) {
        this.guestMyPriceTotal = res["subTotal"];
      } else {
        this.guestMyPriceTotal = res["subTotal"];
      }

      this.Guest_Discount =
        Number(this.guestMyPriceTotal) - Number(this.guestSubTotal);

      if (
        this.freeDelivery?.isdelivery &&
        this.guestSubTotal < this.freeDelivery?.freeDeliveryAmount &&
        this.optionType == "DELIVERY"
      ) {
        this.guestGTotal =
          Number(this.guestSubTotal) +
          Number(this.guestTax) +
          Number(this.freeDelivery?.deliveryCharges);
      } else {
        this.guestGTotal = Number(this.guestSubTotal) + Number(this.guestTax);
      }
    });
  }

  Guest_Discount;
  guest_subtotal;
  gettaxforFirstScreen;
  getOffineCartAmountResult;
  // actualprice=0
  getOffineCartAmount(): number {
    let discountedSum = 0;
    let originalPriceSum = 0;

    this.offlineCartProduct.forEach((item) => {
      discountedSum += Number(item.myPrice) * Number(item.quantity);
      originalPriceSum += Number(item.price) * Number(item.quantity);
    });

    discountedSum -= Number(this.calculateOfflineDiscount);
    originalPriceSum -= Number(this.calculateOfflineDiscount);

    // Apply delivery charge logic
    const deliveryCharge = discountedSum < 100 ? this.backendDeliveryCharge : 0;

    this.offlineDeliveryCharge = deliveryCharge;

    discountedSum += deliveryCharge;
    originalPriceSum += deliveryCharge;

    this.Guest_Discount = this.calulateOnly_cartDiscount(
      this.offlineCartProduct,
    );
    this.guest_subtotal = originalPriceSum;
    this.GETaCTUALpRICE = originalPriceSum;
    this.CartSubTotal = originalPriceSum;
    this.getOffineCartAmountResult = discountedSum;

    return originalPriceSum;
  }

  setemptyHoverValue(index) {
    this.newArrivalIndex = -1;
  }

  errorMsg;
  CartData = [];

  addToCart(productDetails) {
    const addressStatus = localStorage.getItem("addressStatus");
    if (addressStatus === null || addressStatus === "false") {
      $("#SearchLocation").modal("show");
    } else if (!this.auth) {
      this.offlineWeightCheck(productDetails, false, productDetails);
    } else {
      let limit = localStorage.getItem("cartLimit");
      let limitFlower = localStorage.getItem("cartLimitFlower");
      let obj = {
        inventoryId: productDetails.CatalogItemId,
        selectQuantity: this.qtyValue,
        storeId: Number(localStorage.getItem("localStoreId")),
        orderType: this.getOrderType(),
        productId: productDetails.CatalogItemId,
        otherWtSum: limit,
        flowerWtSum: limitFlower,
        qtyIncrease: true,
        recommended: "NO",
        categoryId: this._bs.fetchCategoryId(productDetails?.category),
      };
      this.loaderSrv.startLoader("", "");
      this.commonService.addProductInCartnew(obj).subscribe((res) => {
        if (res["meta"]["status"]) {
          this.commonService.emittedCartValue.next(true); // header function for cart count

          this._dataLayerService.addToCartGTM(res["data"]["addtoCart"]);
          this.updateCartObservableFunction(res);
          this.showLoginStaffPick = true;
          this.recommendedProductsList = res["RecomendedProducts"];
          let userCartLength = res["data"]["addtoCart"]
            ? res["data"]["addtoCart"].length
            : 0;
          this.cartLengthService.cartLengthUpdateFunction(userCartLength); //update header cart count
          this.loaderSrv.changeStateandStopLoader(
            "success",
            "Added to Cart",
            1000,
          );
        } else {
          this.errorMsg = res["meta"]["msg"];

          if (
            this.errorMsg ===
            "Store must be unique ! Please try again with same store"
          ) {
            $("#exampleModal").modal("show");
            this.loaderSrv.stopLoader();
          } else if (
            this.errorMsg == "You can not add products more than {{}}"
          ) {
            $("#cartLimitModal").modal("show");
            this.loaderSrv.stopLoader();
          } else {
            this.loaderSrv.changeStateandStopLoader(
              "error",
              res["meta"]["msg"],
              3000,
            );
          }
        }
      });
    }
  }

  newArrivalIndex;
  setNewArrivalValue(index) {
    this.newArrivalIndex = index;
  }

  getImageSize3(array) {
    if (array.length) {
      return array[0]["Uri"];
    } else {
      return this.defaultUrl;
    }
  }

  getBackGroundColor(tag) {
    if (tag) {
      return tag.tagColor;
    } else {
      return "#FFFFFF";
    }
  }
  getBackGroundColorAccToSpecies(name) {
    return "#f8f8f8";
  }

  getTextIconColor(sty, type?) {
    let style: any;
    this.siteDada = JSON.parse(localStorage.getItem("siteData"));
    if (this.siteDada?.headerTextColor) {
      style = sty;
    }
    if (!this.siteDada?.headerTextColor && type == "HOURS") {
      style = { "background-color": "gray" };
    }
    if (!this.siteDada?.headerTextColor && type == "Powered") {
      style = { color: "#fff" };
    }
    return style;
  }

  VARID;
  PREVIOUSVARID; // for clearing the varqtyvalue to 0 if we click diff div
  HandleVarinceAddToCartOrNot(data, index) {
    if (!this.PREVIOUSVARID) {
      this.VARID = data._id;
      this.PREVIOUSVARID = data._id;
    } else {
      if (this.PREVIOUSVARID != data._id) {
        this.varqtyvalue = 0;
        this.VARID = data._id;
        this.PREVIOUSVARID = data._id;
      }
    }
  }

  actualId;
  isShown;
  varianceArray = [];
  showVariance;
  showVarianceList(array, catalogItemId) {
    this.actualId = catalogItemId;
    this.isShown = true; //collect varient data
    this.varianceArray = array;
    this.showVariance = true;
  }

  pickUpStatus;
  orderType;
  getOrderType() {
    this.optionType = localStorage.getItem("optionType");

    if (this.optionType == "CURBSIDE") {
      this.orderType = "CurbsidePickup";
    } else if (this.optionType == "DELIVERY") {
      this.orderType = "Delivery";
    } else if (this.optionType == "PICKUP") {
      this.orderType = "Pickup";
    }

    return this.orderType;
  }

  showDiv1(item) {
    this.varqtyvalue = 0;
    this.actualId = item;
    this.isShown = false;
    this.VARID = "";
  }

  paymentMethodcash;
  guestTax;
  guestSubTotal;
  guestGTotal;
  guestDilveryC;
  guestdilveryShow;
  radiobtnonForCash_guest;
  guestMyPriceTotal;

  ShowGuestOptionFirst() {
    let pickup = localStorage.getItem("isPickUpOrder");
    this.step = 2;
    if (pickup == "true") {
      var currentLastStoreAddress = localStorage.getItem("storeCurrentAddress");
      localStorage.setItem("addressString", currentLastStoreAddress);
      this.addressString = currentLastStoreAddress;
    }
    this.showTimeSlotDiv = true;
    if (pickup == "false") {
      this.selected_date_text = "Select Delivery Date ";
    } else {
      this.selected_date_text = "Select Pickup Date ";
    }
  }

  GuestMode(val) {
    let offlineProduct1 = JSON.parse(localStorage.getItem("cartProduct"));
    let productArray2 = offlineProduct1["product"];
    this.addressString = localStorage.getItem("addressString");
    let Array = [];
    productArray2.forEach((elm) => {
      Array.push({
        myPrice: elm.myPrice ? elm.myPrice : elm.price,
        price: elm.price,
        selectQuantity: elm.quantity,
        CatalogItemId: elm.productId,
        storeId: localStorage.getItem("localStoreId"),
      });
    });
  }

  canRequest;
  increaseDecreaseQuantity(
    productId,
    optionId,
    optionTypeId,
    productType,
    productWeight,
    productName,
    event,
    inventoryId,
    selectedQuantity,
    boolean,
    product,
  ) {
    if (this.canRequest) {
      this.canRequest = false;
      let obj = {
        productId: productId,
        optionId: optionId,
        optionTypeId: optionTypeId,
        productType: productType,
        selectQuantity: 1,
        weight: productWeight,
        productName: productName,
        inventoryId: inventoryId,
        storeId: localStorage.getItem("localStoreId"),
        wtSum: localStorage.getItem("cartLimit"),
        categoryId: this._bs.fetchCategoryId(product?.categoryArr),
      };
      if (!boolean) {
        obj["qtyIncrease"] = false;
        obj["selectQuantity"] = 1;
      } else {
        obj["qtyIncrease"] = true;
      }

      $("#loadMe").modal("show");
      this.commonService.increaseProductQuantityInCart(obj).subscribe((res) => {
        this.getCartProduct();
        $("#loadMe").modal("hide");
        this.canRequest = true;
        if (res["meta"]["status"]) {
          this.commonService.emittedCartValue.next(true); // header function for cart count

          this.updateCartObservableFunction(res);
          let userCartLength = res["data"]["addtoCart"]
            ? res["data"]["addtoCart"].length
            : 0;
          this.cartLengthService.cartLengthUpdateFunction(userCartLength);
          if (this.router.url.includes("/checkout")) {
            location.reload();
          }
          this.loaderSrv.close();
        } else {
          $("#loadMe").modal("hide");
          this.outOfStockMessage = res["meta"]["msg"];
          setTimeout(() => {
            this.outOfStockMessage = "";
          }, 1500);
          this.loaderSrv.changeStateandStopLoader(
            "error",
            res["meta"]["msg"],
            1000,
          );
        }
      });
    }
  }
  unsubsribeCartObservable(res) {
    // $("#loadMe").modal("hide");
    this.logincartProduct = res;
    this.cartProduct$ = of(res);
    this.cartLength = 0;
    this.weightLimit = 0;
    localStorage.setItem("cartLimit", this.weightLimit);
    localStorage.setItem("loggedInCart", String(this.cartLength));
    this.commonService.updateCartProduct(0);
    this.cartSum = "$" + 0;
    this.cartMessageError = "";
    this.userSrv.updateCartMessage("");
  }

  getFinalDisc_authCase(gt, disc) {
    if (
      this.freeDelivery?.isdelivery &&
      this.optionType == "DELIVERY" &&
      this.logincartProduct?.subTotal < this.freeDelivery?.freeDeliveryAmount
    ) {
      let sumof_gt_tip =
        Number(gt) +
        Number(this.driver_tip ? this.driver_tip : 0) +
        Number(this.freeDelivery?.deliveryCharges);
      let final = sumof_gt_tip - disc;
      return final.toFixed(2);
    } else if (this.show_tip_in_cart) {
      let sumof_gt_tip = Number(gt) + Number(this.driver_tip);
      let final = sumof_gt_tip - disc;
      return final;
    } else {
      let output = gt - disc;
      return output.toFixed(2);
    }
  }
  getFinalDisc_guestCase(guestGtotal) {
    if (this.show_tip_in_cart) {
      let guestGtotalWithTip =
        Number(guestGtotal) + Number(this.driver_tip ? this.driver_tip : 0);
      let final = guestGtotalWithTip;
      return final?.toFixed(2);
    } else {
      return guestGtotal?.toFixed(2);
    }
  }

  updateCartObservableFunction(res) {
    if (res["data"]?.addtoCart?.length == 1) {
      this.getCartProduct();
    } else {
      this.cartProduct$ = of(res);
      this.cartProduct$.subscribe((res) => {
        this.logincartProduct = res;
        this.weightLimit = res["otherWtSum"];
        this.weightLimitFlower = res["flowerWtSum"];
        let percentage = (this.weightLimit / this.CartBarLimit) * 100;
        let percentageFlower =
          (this.weightLimitFlower / this.CartBarLimitFlower) * 100;
        if (res["minimumCartValuebyCity"]) {
          this.CompareWithSubTotal =
            res["minimumCartValuebyCity"]?.currentStoreMinCartValue;
          this.CartSubTotal = Number(res["subTotal"]);
        }
        if (this.weightLimit) {
          this.progressbarWidth = String(percentage?.toFixed(0)) + "%";
        } else {
          this.progressbarWidth = String(percentage?.toFixed(0) + "%");
        }
        if (this.weightLimitFlower) {
          this.progressbarWidthFlower =
            String(percentageFlower?.toFixed(0)) + "%";
        } else {
          this.progressbarWidthFlower = String(
            percentageFlower?.toFixed(0) + "%",
          );
        }
        localStorage.setItem("cartLimit", this.weightLimit);
        this.recommendedProductsList = res["RecomendedProducts"];
        this.showLoginStaffPick = true;
      });
    }
    this.getStaffPicsList();
  }

  removeProduct(subProductId, productId, loader) {
    let obj = {
      productSubId: subProductId,
      productId: productId,
    };
    if (loader == true) {
      $("#loadMe").modal("show");
    }
    this.commonService.removeProductFromCart(obj).subscribe((res) => {
      $("#loadMe").modal("hide");
      if (res["meta"]["status"]) {
        $("#loadMe").modal("hide");

        this.showLoginStaffPick = true;
        this.recommendedProductsList = res["RecomendedProducts"];
        let userCartLength = res["data"]["addtoCart"]
          ? res["data"]["addtoCart"].length
          : 0;

        if (userCartLength > 0) {
          this.updateCartObservableFunction(res);
        } else {
          this.unsubsribeCartObservable(res);
        }

        this.cartLengthService.cartLengthUpdateFunction(userCartLength);
        if (this.router.url.includes("/checkout")) {
          if (this.cartLength === 1) {
            this.router.navigateByUrl("/shop");
          } else {
            location.reload();
          }
        }
      } else {
        $("#loadMe").modal("hide");
        if (res["meta"]["msg"] == "No Product found in your cart.") {
          this.cartLengthService.cartLengthUpdateFunction(0);
          this.unsubsribeCartObservable(res);
        }
      }
    });
  }

  //---------------------------------------after verify age popup------------------------------------------------------------------------
  selectMailOrder(status) {
    this.oldDeliverySelectUserStatus = localStorage.getItem("isPickUpOrder");
    localStorage.clear();
    localStorage.setItem("isPickUpOrder", status);
    localStorage.setItem("isPickUpOrder", status);
    localStorage.setItem("isPickUpOrder", status);
    if (status === "true") {
      $("#SearchLocation").modal("show");
    } else {
      if (this.addressString == null) {
        this.addressString = "";
      }
    }
    this.isPickup = status;
    $("#selectOrderStatusPopup").modal("hide");
    if (
      localStorage.getItem("addressStatus") === undefined ||
      localStorage.getItem("addressStatus") === null
    ) {
      $("#SearchLocation").modal("show");
    } else {
      if (
        status !== this.oldDeliverySelectUserStatus &&
        this.cartLength !== 0
      ) {
      } else {
        this.checkPostalCodeOnDeliverySelection();
      }
    }
  }

  checkMailOrderButtonStatus() {
    let status = localStorage.getItem("isPickUpOrder");
    if (status === "false") {
      return true;
    } else {
      return false;
    }
  }

  checkDeliveryButtonStaus() {
    let status = localStorage.getItem("isPickUpOrder");
    if (status === "true") {
      return true;
    } else {
      return false;
    }
  }

  closePickUpStorePopUp() {
    $("#SearchLocation").modal("hide");
  }

  //gmap
  newStoreName;
  a;
  b;
  c;
  d;
  e;
  fi;
  g;
  h;
  i;
  j;
  k;
  l;
  m;
  n;
  curretStoreName;

  undoDataforStore() {
    this.curretStoreName = "";
  }
  updatePickUpStoreData(
    storeId,
    storeName,
    storeAccountNum,
    authorization,
    addressLine1,
    addressLine2,
    city,
    state,
    stateCode,
    country,
    countryCode,
    zip,
    addressObj,
    lat,
    long,
    check,
    isPickUpOrder,
    isReload,
  ) {
    this.loaderSrv.stopLoader();

    var newAddress = addressLine1 + " " + city + " " + stateCode + " " + zip;
    if (isReload == "false") {
      localStorage.setItem("storeCurrentAddress", this.pickupAddress);
    } else {
      var newAddress = addressLine1 + " " + city + " " + stateCode + " " + zip;
      localStorage.setItem("storeCurrentAddress", newAddress);
    }
    let localsStoreId = localStorage.getItem("localStoreId");

    if (localsStoreId == storeId) {
      $("#SearchLocation").modal("hide");

      this.loaderSrv.stopLoader();
      if (isPickUpOrder == "true") {
        this.modalText = "Pickup";
        localStorage.setItem("isPickUpOrder", "true");
        this.isDelivery = false;
        this.pickupAddress =
          addressLine1 + " " + city + " " + stateCode + " " + zip;

        this.addressString = this.pickupAddress;
        localStorage.setItem("addressString", this.pickupAddress);
      } else {
        localStorage.setItem("addressString", this.addressFormattedAddress);
      }
      if (isReload != "false") {
        this.router.navigateByUrl("/");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } else {
      this.loaderSrv.startLoader("", "");
      this.addressString = this.pickupAddress;
      let currentStoreName = localStorage.getItem("localStoreName");
      this.newStoreName = storeName;
      this.curretStoreName = currentStoreName;
      let cart = JSON.parse(localStorage.getItem("cartProduct"));
      var length;
      this.a = storeId;
      this.storeAccountNum = storeAccountNum;
      this.authorization = authorization;
      ((this.b = storeName),
        (this.c = addressLine1),
        (this.d = addressLine2),
        (this.e = city),
        (this.fi = state),
        (this.g = stateCode),
        (this.h = country),
        (this.i = countryCode),
        (this.j = zip),
        (this.k = addressObj),
        (this.l = lat),
        (this.m = long),
        (this.n = check));
      if (isPickUpOrder == "false") {
        this.pickupAddress = addressLine2;
      } else {
        this.pickupAddress =
          addressLine1 + " " + city + " " + stateCode + " " + zip;
      }
      if (cart) {
        length = cart["product"].length; //offline length
      } else {
        length = 0;
      }
      if (this.isPickup == "true") {
        this.modalText = "Pickup";
        this.addressString = this.pickupAddress;
        localStorage.setItem("addressString", this.pickupAddress);
      } else {
        this.modalText = "Delivery";
        this.addressString = this.addressFormattedAddress;
        localStorage.setItem("addressString", this.addressFormattedAddress);
      }
      if (!this.auth && length > 0 && Number(localsStoreId) !== storeId) {
        this.loaderSrv.stopLoader();
      }

      if (
        Number(localStorage.getItem("loggedInCart")) > 0 &&
        Number(localsStoreId) !== storeId
      ) {
        this.loaderSrv.stopLoader();
      } else {
        if (
          lat != undefined &&
          long != undefined &&
          lat != "undefined" &&
          long != "undefined"
        ) {
          localStorage.setItem(
            "addressLatitude",
            localStorage.getItem("currentLat"),
          );
          localStorage.setItem(
            "addressLongitude",
            localStorage.getItem("currentLong"),
          );
        }
        localStorage.setItem("addressStatus", "true");

        localStorage.setItem("postal_code", zip);
        localStorage.setItem("city", city);
        localStorage.setItem("state", state);
        localStorage.setItem("stateCode", stateCode);
        localStorage.setItem("country", country);
        localStorage.setItem("countryCode", countryCode);
        localStorage.setItem("dilveryStatus", "true");
        localStorage.setItem("isPickUpOrder", isPickUpOrder);
        localStorage.setItem("localStoreId", storeId);
        localStorage.setItem("localStoreName", storeName);
        localStorage.setItem("storeAccountNum", storeAccountNum);
        localStorage.setItem("authorization", authorization);
        this.userId = localStorage.getItem("covaUserId");
        this.userName = localStorage.getItem("userName");
        let obj = {
          CustomerId: this.userId,
          AddressTypeId: 2,
          AttentionTo: this.userName,
          CountryCode: countryCode,
          Default: false,
          DoNotContact: true,
          Email: localStorage.getItem("email"),
          Locality: city,
          Notes: "",
          Phone: localStorage.getItem("mobile"),
          PostalCode: zip,
          PostOfficeBoxNumber: "",
          StateCode: stateCode,
          StreetAddress1: addressLine1,
          StreetAddress2: addressLine2,
          currentLat: localStorage.getItem("currentLat"),
          currentLong: localStorage.getItem("currentLong"),
          // currentLat: 49.31820997936569,
          // currentLong: -124.29653501338164,
          formattedAddress: this.pickupAddress,
        };
        if (this.auth) {
          this.commonService.saveAddress(obj).subscribe((res) => {
            this.loaderSrv.stopLoader();

            $("#SearchLocation").modal("hide");
            if (isReload != "false") {
              this.router.navigateByUrl("/");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          });
        } else {
          this.loaderSrv.stopLoader();
          $("#SearchLocation").modal("hide");
          if (localStorage.getItem("isSwitch") == "true") {
            localStorage.setItem("isSwitch", "false");
            localStorage.removeItem("cartProduct");
            localStorage.removeItem("cartProduct");
          }
          if (isReload != "false") {
            this.router.navigateByUrl("/");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }
      }
      this.loaderSrv.stopLoader();
    }
  }

  searchCloseBtnClick() {
    this.isPickup = localStorage.getItem("isPickUpOrder");
    if (this.isPickup == "true") {
      localStorage.setItem("isPickUpOrder", "true");
    } else {
      localStorage.setItem("isPickUpOrder", "false");
    }

    if (this.router.url.match("/checkout")) {
      $("#addressInputField").val(localStorage.getItem("addressString"));
    }
  }

  newStoreHandle;
  currentstoreHandle;
  addressField: boolean = false;
  tomaddressData: any = [];
  postalAddressData: any = [];
  getAddresss(address) {
    if (address.target.value.length == 0) {
      this.tomaddressData = [];
    }
    if (address.target.value.length < 3) {
      return;
    }
    this.tomaddressData = [];
    this.postalAddressData = [];
    this.commonService.adressGets(address.target.value).subscribe((res) => {
      if (res["features"]) {
        this.addressField = true;
        this.tomaddressData = res["features"];
      } else {
        this.tomaddressData = [];
      }
    });
  }
  freeDelivery: any;
  isAddressCorrect:boolean = false
  chooseAddressForMapBox(address) {
    this.isPickup = "false";
    this.addressPostalCode = "";
    this.addressString = address.place_name;
    this.addressFormattedAddress = address.place_name;
    this.addressCurrentLat = address?.geometry?.coordinates[1];
    this.addressCurrentLong = address?.geometry?.coordinates[0];

    localStorage.setItem("currentLat", this.addressCurrentLat);
    localStorage.setItem("currentLong", this.addressCurrentLong);
    if (address.id.split(".")[0] == "postcode") {
      this.addressPostalCode = address.text;
      address?.context?.forEach((element) => {
        if (element.id.split(".")[0] == "neighborhood") {
          this.addressNeighborhood = element.text;
          this.addressLocality = element.text;
          this.addressRoute = element.text;
        }
        if (element.id.split(".")[0] == "place") {
          this.addressStreetNumber = element.text;
        }
        if (element.id.split(".")[0] == "region") {
          this.addressAdministrationLevel = element.text;
        }
        if (element.id.split(".")[0] == "country") {
          this.addressCountry = element.text;
        }
      });
    } else {
      address?.context?.forEach((element) => {
        if (element.id.split(".")[0] == "neighborhood") {
          this.addressNeighborhood = element.text;
          this.addressLocality = element.text;
          this.addressRoute = element.text;
        }
        if (element.id.split(".")[0] == "postcode") {
          this.addressPostalCode = element.text;
        }
        if (element.id.split(".")[0] == "place") {
          this.addressStreetNumber = element.text;
        }
        if (element.id.split(".")[0] == "region") {
          this.addressAdministrationLevel = element.text;
        }
        if (element.id.split(".")[0] == "country") {
          this.addressCountry = element.text;
        }
      });
    }
    if (this.isPickup === "false" && this.addressPostalCode != "") {
          $("#loadMe").modal("show");
      this.commonService.checkPostalCode({postalCode: this.addressPostalCode,storeId: this.storeId,}).subscribe((res) => {
      $("#loadMe").modal("hide");
          if (res["meta"]["status"]) {

            localStorage.setItem(
              "cityForCompare",
              res["regionData"]["regionName"],
            );
            this.cartLengthService.stpredataUpdate(res["data"]);
            this.loaderSrv.stopLoader();
            console.log(res, "reddddd");

            if (res["pickupStoreListInThisRegion"] == 0) {
              $("#shoppingCart").modal("hide");
              this.loaderSrv.stopLoader();
            } else {
              this.loaderSrv.stopLoader();
              let currentStore = localStorage.getItem("localStoreId");
              this.currentstoreHandle = currentStore;
              this.addressString = this.addressFormattedAddress;
              let responseStore = res["data"].Id;
              this.isAddressCorrect = true
              let cart = JSON.parse(localStorage.getItem("cartProduct"));
              var length;
              if (cart) {
                length = cart["product"].length; //offline length
              } else {
                length = 0;
              }

              this.modalText = "delivery";
              if (Number(currentStore) !== responseStore) {
                this.addressString = "";
                if (!this.auth && length > 0) {
                  this.loaderSrv.stopLoader();
                  $("#shoppingCart").modal("hide");
                }
                if (
                  this.auth &&
                  Number(localStorage.getItem("loggedInCart")) > 0
                ) {
                  this.loaderSrv.stopLoader();
                  $("#shoppingCart").modal("hide");
                }
              } else {
                this.pickupAddress = res["data"].Address.AddressLine1 +" " + res["data"].Address.City +  " " +  res["data"].Address.StateName + " " + res["data"].Address.CountryName;
                this.addressString = this.addressFormattedAddress;
                this.storeId = res["data"]?.Id;
                this.storeName = res["data"]?.Name;
                this.storeCurrentAddress = this.pickupAddress;
                this.storeAccountNum = res["data"]?.storeAccountNum;
                this.authorization = res["data"]?.authorization;
                this.newStoreHandle = this.storeName;
                this.updatePickUpStoreData(
                  res["data"].Id,
                  this.storeName,
                  this.storeAccountNum,
                  this.authorization,
                  this.addressStreetNumber,
                  this.addressString,
                  res["data"].Address.City,
                  res["data"].Address.StateName,
                  this.addressAdministrationLevel,
                  res["data"].Address.CountryName,
                  this.addressCountryCode,
                  this.addressPostalCode,
                  this.addressFormattedAddress,
                  this.addressCurrentLat,
                  this.addressCurrentLong,
                  this.isPickup,
                  "false",
                  "false",
                );
              }
            }
            let obj = {
              city: localStorage.getItem("cityForCompare"),
              orderType: this.getOrderType(),
              storeId: localStorage.getItem("localStoreId"),
            };
            if (localStorage.getItem("optionType") == "DELIVERY") {
              this.commonService.guestCartValueCheck(obj).subscribe((res) => {
                this.storeAmount = res["minimumCartValuebyCity"]?.currentStoreMinCartValue;
                if (res["minimumCartValuebyCity"]["currentStoreMinCartValue"] > Number(this.CartSubTotal)) {
                  $("#limitModal10").modal("show");
                  this.freeDelivery = res["minimumCartValuebyCity"];
                  this.guestModeOn = false;
                  this.showTimeSlotDiv = false;
                  this.showPlaceOrderDiv = false;
                  if (this.auth) {
                    this.backFrom_checkout_auth();
                  } else {
                    this.backFrom_checkout_guest();
                  }
                } else {
                  this.freeDelivery = res["minimumCartValuebyCity"];
                }
              });
            }
          } else {
            this.loaderSrv.stopLoader();
            this.tomaddressData = []
            this.isAddressCorrect = false;
            this.addressString = "";
            Swal.fire({
              title: "Opps",
              text: res["meta"]["msg"],
              icon: "error",
            });
            return

          }
        });
    } else {
      this.loaderSrv.stopLoader();
      this.addressString = "";
    }
    this.addressField = false;
  }
  getStoreMObile() {
    let currentstoreid = Number(localStorage.getItem("localStoreId"));
    let mno: any = this.pickUpStoreList?.find(
      (a) => a?.Id == currentstoreid,
    )?.storeMobile;
    return mno;
  }

  closeModels() {
    this.guestModeOn = false;
    this.showTimeSlotDiv = false;
    this.showPlaceOrderDiv = false;
    if (this.auth) {
      this.backFrom_checkout_auth();
    } else {
      this.backFrom_checkout_guest();
    }
  }
  count: number = 0;

  cartValueCheck(val: any, purchaseAmount) {
    this.optionType = localStorage.getItem("optionType");
    this.isOptionSubmitted = true;
    this.count = this.count + 1;
    
  
    this.choosenTimeSlot = this.timiSelected;
    if ( this.choosenTimeSlot == undefined || this.choosenTimeSlot == "" || this.choosenTimeSlot == null) {
      setTimeout(() => {
        this.timeSlotErr = "";
      }, 5000);
      this.count = 0;
      return (this.timeSlotErr = "Time Slot is required ");
    }
    if (this.optionType == "DELIVERY") {
      if (!this.isAddressCorrect) {
        return
      }
        if (!this.addressString) {
          this.count = 0;
          return;
        }
      }

    if (this.auth) {
      this.saveDeliverAddressAfterLogin();
    }
    let pickup = localStorage.getItem("isPickUpOrder");
    if (val == 0) {
      this.managePlaceOrderDiv(val);
    }
    if (pickup == "true") {
      this.submitted = true;
      this.managePlaceOrderDiv(val);
      }

      this.choosenTimeSlot = this.timiSelected;
      this.timeConverter(this.timiSelected, this.timiSelected);
      this.userId = localStorage.getItem("covaUserId");
      this.userName = localStorage.getItem("userName");

      setTimeout(() => {
        if (
          localStorage.getItem("optionType") == "CURBSIDE" ||
          localStorage.getItem("optionType") == "DELIVERY"
        ) {
          this.radiobtnonForCash_auth = true;
          this.getPaymentMethodOption("", "cash");
        }
      }, 500);
      if (
        this.optionType == "DELIVERY" &&
        (this.addressFormattedAddress == "" ||
          this.addressFormattedAddress == undefined ||
          this.addressFormattedAddress == null)
      ) {
        this.count = 0;
        return;
      }

      let obj: any;
      if (this.optionType == "DELIVERY") {
        obj = {
          CustomerId: this.userId,
          AddressTypeId: 2,
          AttentionTo: this.userName,
          CountryCode: this.addressCountry,
          Default: false,
          DoNotContact: true,
          Email: "",
          Locality: this.addressLocality,
          Notes: this.addressRoute,
          Phone: "",
          PostalCode: this.addressPostalCode,
          PostOfficeBoxNumber: this.addressRoute,
          StateCode: this.addressAdministrationLevel,
          StreetAddress1: localStorage.getItem("addressString"),
          StreetAddress2: localStorage.getItem("address"),
          currentLat: localStorage.getItem("currentLat"),
          currentLong: localStorage.getItem("currentLong"),
          formattedAddress: localStorage.getItem("addressString"),
        };
      } else {
        let storeInfo: any = localStorage.getItem("storeInfo");
        storeInfo = JSON.parse(storeInfo);
        obj = {
          CustomerId: this.userId,
          AddressTypeId: 2,
          AttentionTo: this.userName,
          CountryCode: storeInfo?.Address["CountryCode"],
          Default: false,
          DoNotContact: true,
          Email: "",
          Locality: this.addressLocality,
          Notes: this.addressRoute,
          Phone: "",
          PostalCode: storeInfo?.Address["Zip"],
          PostOfficeBoxNumber: this.addressRoute,
          StateCode: storeInfo?.Address["StateCode"],
          StreetAddress1: storeInfo?.Address["AddressLine2"],
          StreetAddress2: storeInfo?.Address["AddressLine2"],
          currentLat: storeInfo?.location["coordinates"][1],
          currentLong: storeInfo?.location["coordinates"][0],
          formattedAddress: storeInfo?.Address["AddressLine2"],
        };
      }

      $("#loadMe").modal("show");
      this.commonService.saveAddress(obj).subscribe((res) => {
        if (res["meta"]["status"]) {
          $("#loadMe").modal("hide");

          let objNew = {
            city: localStorage.getItem("cityForCompare"),
            orderType: this.getOrderType(),
            storeId: localStorage.getItem("localStoreId"),
          };
          this.radiobtnonForCash_auth = true;
          if (this.optionType == "DELIVERY") {
            this.commonService.guestCartValueCheck(objNew).subscribe((res) => {
              this.storeAmount =
                res["minimumCartValuebyCity"]?.currentStoreMinCartValue;
              if (
                res["minimumCartValuebyCity"]?.currentStoreMinCartValue >
                Number(purchaseAmount)
              ) {
                $("#limitModal10").modal("show");
                this.guestModeOn = false;
                this.showTimeSlotDiv = false;
                this.showPlaceOrderDiv = false;
                if (this.auth) {
                  this.backFrom_checkout_auth();
                } else {
                  this.backFrom_checkout_guest();
                }
              } else {
                this.step = 3;
                this.managePlaceOrderDiv(val);
              }
            });
          } else {
            this.step = 3;
          }

          localStorage.setItem("addressStatus", "true");
        }
      });
    
    
  }

  callDeliveryStoreSelected(index) {
    this.isPickup = "false";
    localStorage.setItem("isPickUpOrder", "false");
    this.addressString = this.addressFormattedAddress;
    let currentStore = localStorage.getItem("localStoreName");
    this.currentstoreHandle = currentStore;
    this.storeId = this.pickupStoreListInThisRegion[index].Id;
    this.storeName = this.pickupStoreListInThisRegion[index].Name;
    this.storeAccountNum =
      this.pickupStoreListInThisRegion[index].storeAccountNum;
    this.authorization = this.pickupStoreListInThisRegion[index].authorization;
    (localStorage.setItem("storeAccountNum", this.storeAccountNum),
      localStorage.setItem("authorization", this.authorization));
    this.newStoreHandle = this.storeName;
    let cart = JSON.parse(localStorage.getItem("cartProduct"));
    var length;
    if (cart) {
      length = cart["product"].length; //offline length
    } else {
      length = 0;
    }
    this.modalText = "delivery";
    this.updatePickUpStoreData(
      this.storeId,
      this.storeName,
      this.storeAccountNum,
      this.authorization,
      this.addressStreetNumber,
      this.addressFormattedAddress,
      this.addressCity,
      this.addressState,
      this.addressAdministrationLevel,
      this.addressCountry,
      this.addressCountryCode,
      this.addressPostalCode,
      this.addressFormattedAddress,
      this.addressCurrentLat,
      this.addressCurrentLong,
      false,
      "false",
      "false",
    );
  }

  emptyguestcart() {
    localStorage.removeItem("cartProduct");
    localStorage.removeItem("cartProduct");
    this.updatePickUpStoreDataaftertap(
      this.a,
      this.b,
      this.storeAccountNum,
      this.authorization,
      this.c,
      this.d,
      this.e,
      this.fi,
      this.g,
      this.h,
      this.i,
      this.j,
      this.k,
      this.l,
      this.m,
      this.n,
    );
  }

  updatePickUpStoreDataaftertap(
    storeId,
    storeName,
    storeAccountNum,
    authorization,
    addressLine1,
    addressLine2,
    city,
    state,
    stateCode,
    country,
    countryCode,
    zip,
    addressObj,
    lat,
    long,
    check,
  ) {
    this.a = storeId;
    ((this.b = storeName),
      (this.c = addressLine1),
      (this.d = addressLine2),
      (this.e = city),
      (this.fi = state),
      (this.g = stateCode),
      (this.h = country),
      (this.i = countryCode),
      (this.j = zip),
      (this.k = addressObj),
      (this.l = lat),
      (this.m = long),
      (this.n = check));

    if (check == "false") {
      this.pickupAddress = addressLine2;
    } else {
      this.pickupAddress =
        addressLine1 + " " + city + " " + stateCode + " " + zip;
    }

    if (
      lat != undefined &&
      long != undefined &&
      lat != "undefined" &&
      long != "undefined"
    ) {
      localStorage.setItem("addressLatitude", lat);
      localStorage.setItem("addressLongitude", long);
    }
    this.selectedStoreAddress = this.pickupAddress;
    localStorage.setItem("addressString", this.pickupAddress);
    localStorage.setItem("addressStatus", "true");
    localStorage.setItem("postal_code", zip);
    localStorage.setItem("isPickUpOrder", check);
    localStorage.setItem("city", city);
    localStorage.setItem("state", state);
    localStorage.setItem("stateCode", stateCode);
    localStorage.setItem("country", country);
    localStorage.setItem("countryCode", countryCode);
    localStorage.setItem("dilveryStatus", "true");
    localStorage.setItem("localStoreId", storeId);
    localStorage.setItem("localStoreName", storeName);
    localStorage.setItem("storeAccountNum", storeAccountNum);
    localStorage.setItem("authorization", authorization);
    this.userId = localStorage.getItem("covaUserId");
    this.userName = localStorage.getItem("userName");
    let obj = {
      CustomerId: this.userId,
      AddressTypeId: 2,
      AttentionTo: this.userName,
      CountryCode: countryCode,
      Default: false,
      DoNotContact: true,
      Email: localStorage.getItem("email"),
      Locality: city,
      Notes: "",
      Phone: localStorage.getItem("mobile"),
      PostalCode: zip,
      PostOfficeBoxNumber: "",
      StateCode: stateCode,
      StreetAddress1: addressLine1,
      StreetAddress2: addressLine2,
      currentLat: lat,
      currentLong: long,
      // currentLat: 49.31820997936569,
      // currentLong: -124.29653501338164,
      formattedAddress: this.pickupAddress,
    };

    this.router.navigate(["/"]);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  clearLogeedInusercart() {
    if (this.auth) {
      this.loaderSrv.startLoader("Please Wait..", "");
      this.commonService.UserCartClear().subscribe((res) => {
        this.loaderSrv.stopLoader();
        if (res["meta"].status == true) {
          setTimeout(() => {
            this.updateCartState();
            this.canShowThankyoupage = false;
            this.cartLength = 0;
          }, 500);
        }
      });
    } else {
      this.loaderSrv.startLoader("Please Wait..", "");
      localStorage.removeItem("cartProduct");
      localStorage.removeItem("loggedInCart");
      setTimeout(() => {
        this.updateCartState();
        this.loaderSrv.stopLoader();
      }, 500);
    }
  }

  updateCartState() {
    this.commonService.emittedCartValue.next(true);
    this.cartLengthService.cartLengthUpdateFunction(0);
  }

  getOrderTypeSelected() {
    var orderType = "Delivery to Pickup";
    if (localStorage.getItem("toChangeStatus") == "false") {
      orderType = "Pickup to Delivery";
    } else {
      orderType = "Delivery to Pickup";
    }
    return orderType;
  }

  setLocalStorage(user: User, token) {
    localStorage.setItem("covaUserId", user["covaUserId"]);
    localStorage.setItem("userId", user["userId"]);
    localStorage.setItem("mobileVerified", user.mobileVerified);
    localStorage.setItem("userName", user.firstName + " " + user.lastName);
    localStorage.setItem("documentVerify", user.documentVerify);
    localStorage.setItem("mobile", user["mobile"]);
    localStorage.setItem("email", user["emailId"]);
    localStorage.setItem("token", token);
    this.updatePickUpStoreData1();
    this.router.navigateByUrl("/");
  }
  getFullName(item: any) {
    if (item != undefined && item != null) {
      return item?.split("")[0];
    }
  }

  updatePickUpStoreData1() {
    this.addressString = localStorage.getItem("addressString");
    this.addressStatus = localStorage.getItem("addressStatus");
    this.addressLatitude = localStorage.getItem("addressLatitude");
    this.addressLongitude = localStorage.getItem("addressLongitude");
    this.postalCode = localStorage.getItem("postal_code");
    this.city = localStorage.getItem("city");
    this.state = localStorage.getItem("state");
    this.stateCode = localStorage.getItem("stateCode");
    this.country = localStorage.getItem("country");
    this.countryCode = localStorage.getItem("countryCode");
    this.dilveryStatus = localStorage.getItem("dilveryStatus");
    this.storeId = localStorage.getItem("localStoreId");
    this.storeName = localStorage.getItem("localStoreName");
    this.storeAccountNum = localStorage.getItem("storeAccountNum");
    this.authorization = localStorage.getItem("authorization");
    this.userId = localStorage.getItem("covaUserId");
    this.userName = localStorage.getItem("userName");
    this.mobile = localStorage.getItem("mobile");
    this.email = localStorage.getItem("email");
    let obj = {
      CustomerId: this.userId,
      AddressTypeId: 2,
      AttentionTo: this.userName,
      CountryCode: this.countryCode,
      Default: false,
      DoNotContact: true,
      Email: this.email,
      Locality: this.country,
      Notes: "",
      Phone: this.mobile,
      PostalCode: this.postalCode,
      PostOfficeBoxNumber: this.stateCode,
      StateCode: this.stateCode,
      StreetAddress1: this.addressString,
      StreetAddress2: this.city,
      currentLat: this.addressLatitude,
      currentLong: this.addressLongitude,
      // currentLat: 49.31820997936569,
      // currentLong: -124.29653501338164,
      formattedAddress: this.addressString,
    };
    this.commonService.saveAddress(obj).subscribe((res) => {});
  }

  closeParkPop() {
    $("#parkvillePopUp").modal("hide");
  }

  openPickUpStore() {
    $("#storeHistoryModal").modal("hide");
    $("#SearchLocation").modal("show");
  }

  checkThc(min, max) {
    if (min == 0 && max == 0) {
      return false;
    }
    if (min < max) {
      return true;
    } else {
      return false;
    }
  }

  checkZero(value: any) {
    if (value == 0 || value == null || value == undefined) {
      return false;
    } else {
      return true;
    }
  }
  thcType(type) {
    if (type == 0 || type == null || type == undefined) {
      return "%";
    } else {
      return type;
    }
  }

  storeisOpenOrNot(obj, val) {
    let weekday = new Date().toLocaleString("en-us", { weekday: "long" });
    let a = obj[weekday];
    var currentTime = moment(new Date());
    var StoreOpenTime = a?.Open?.Hour + ":" + a?.Open?.Minute;
    var StoreCloseTime = a?.Close?.Hour + ":" + a?.Close?.Minute;
    var beginningTime = moment(StoreOpenTime, "HH:mm");
    var endTime = moment(StoreCloseTime, "HH:mm");
    if (currentTime > beginningTime && currentTime < endTime) {
      return "OPEN";
    } else {
      return "CLOSED";
    }
  }

  modalClose() {
    $("#storeHistoryModal").modal("hide");
  }

  afterLogin1(user, tokens) {
    this.setLocalStorage1(user, tokens);
    this.userSrv.updateUserAuth(true, user);
    this.openMobileVerify();
  }

  openMobileVerify() {
    document.getElementById("mySideLogin").style.width = "0";
    document.getElementById("mySideRegister").style.width = "0";
    document.getElementById("mySideMobileVerify").style.width = "450px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideMobileVerify").style.width =
          "calc(100%)";
      }
    }

    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal = document.getElementById("mySideMobileVerify");
    modal.focus();
  }

  setLocalStorage1(user: User, token) {
    localStorage.setItem("userId", user["userId"]);
    localStorage.setItem("email", user["emailId"]);
    localStorage.setItem("mobile", user["mobile"]);
    localStorage.setItem("covaUserId", user["covaUserId"]);
    localStorage.setItem("mobileVerified", user.mobileVerified);
    localStorage.setItem("userName", user.firstName + " " + user.lastName);
    localStorage.setItem("documentVerify", user.documentVerify);
    localStorage.setItem("token", token);
  }

  transform(username: string, args: any[]): string {
    return username.split("")[0];
  }
  cancelGuestCheckout() {
    // Clear guest session data
    localStorage.removeItem("guestToken");
    localStorage.removeItem("guestKey");

    // Reset forms
    this.guestAddForm.reset();
    this.CreditCardForm_guest.reset();

    // Reset states
    this.guestModeOn = false;
    this.showTimeSlotDiv = false;
    this.showPlaceOrderDiv = false;
    this.step = 1;
    this.submitted = false;

    // Reload original cart
    this.getOfflineProduct();
  }

  checkPostalCodeOnDeliverySelection() {
    const obj = {
      postalCode: localStorage.getItem("postal_code"),
      userId: localStorage.getItem("userId"),
      deliveryStatus:
        localStorage.getItem("isPickUpOrder") === "true" ? true : false,
    };
    this.commonService.checkPostalCodeInStore(obj).subscribe((res) => {
      if (res["meta"]["status"]) {
        if (res["data"]["deliveryStatus"] === 1) {
          localStorage.setItem("dilveryStatus", "true");
          localStorage.setItem(
            "localStoreId",
            res["data"]["storeData"].storeId,
          );
          localStorage.setItem("regionId", res["data"]["storeData"].regionId);
          localStorage.setItem(
            "regionName",
            res["data"]["storeData"].regionName,
          );
          localStorage.setItem(
            "storeMobile",
            res["data"]["storeData"].storeMobile,
          );
          localStorage.setItem("storeDefault", "nondefault");
          localStorage.setItem("storeDefault", "nondefault");
          this.storeId = res["data"]["storeData"].storeId;
          this.storeName = res["data"]["storeData"].storeName;
          this.storeAccountNum = res["data"]["storeData"].storeAccountNum;
          this.authorization = res["data"]["storeData"].authorization;
          this.storeMobile = res["data"]["storeData"].storeMobile;
          localStorage.setItem(
            "dispatcher",
            res["data"]["storeData"].dispatcher,
          );
          this.userSrv.updateStoreDetails(res["data"]["storeData"]);
          this.getCartProduct();
        } else {
          if (localStorage.getItem("isPickUpOrder") === "false") {
            localStorage.setItem("dilveryStatus", "false");
          } else {
            $("#dilveryNotAvailable").modal("show");
          }
          localStorage.setItem(
            "localStoreId",
            res["data"]["storeData"].storeId,
          );
          localStorage.setItem(
            "regionName",
            res["data"]["storeData"].regionName,
          );
          localStorage.setItem("regionId", res["data"]["storeData"].regionId);
          localStorage.setItem(
            "storeMobile",
            res["data"]["storeData"].storeMobile,
          );
          localStorage.setItem("storeDefault", "nondefault");
          localStorage.setItem("city", res["data"]["storeData"].city);
          this.storeId = res["data"]["storeData"].storeId;
          this.storeName = res["data"]["storeData"].storeName;
          this.storeAccountNum = res["data"]["storeData"].storeAccountNum;
          this.authorization = res["data"]["storeData"].authorization;
          this.storeMobile = res["data"]["storeData"].storeMobile;
          this.userSrv.updateStoreDetails(res["data"]["storeData"]);
          this.getCartProduct();
        }
      }
    });
  }
  //for guest credit card
  cardNumErr_length: Boolean = false;
  CardErrorMsg: string = "";
  onKeydownMain(event): void {
    let cardNum = this.CreditCardForm_guest.value.cardnumber_guest;
    if (!event.shiftKey && (event.key === "Enter" || event.key === "Tab")) {
      if (this.CreditCardForm_guest.value.cardnumber_guest == "") {
        this.cardNumErr = true;
        this.CardErrorMsg = "You must enter the card number";
      } else if (cardNum.length < 16) {
        this.cardNumErr = true;
        this.cardNumErr_length = true;
        this.CardErrorMsg = "You must enter 16 digits";
      } else {
        this.cardNumErr = false;
        this.cardNumErr_length = false;
        this.CardErrorMsg = "";
      }
    } else {
      this.cardNumErr = false;
      this.cardNumErr_length = false;
      this.CardErrorMsg = "";
    }
  }

  onKeypressing(e) {
    const charCode = e.which ? e.which : e.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } else {
      return true;
    }
  }
  getColor() {
    let style: any;
    if (this.siteDada?.headerColor) {
      style = { background: this.siteDada?.headerColor };
    } else {
      style = { background: "#000" };
    }
    return style;
  }
  // for space not allowed
  spaceNotAllowed(e) {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode == 32) {
      return false;
    } else {
      return true;
    }
  }
  firstLaterCaps(event) {
    const str = event.target.value;
    const str2 = str.charAt(0).toUpperCase() + str.slice(1);
    return (event.target.value = str2);
  }

  lettersOnly(event) {
    const str = event.target.value;
    const str2 = str.charAt(0).toUpperCase() + str.slice(1);
    event.target.value = str2;
    var charCode = event.keyCode;
    if (
      (charCode > 64 && charCode < 91) ||
      (charCode > 96 && charCode < 123) ||
      charCode == 8
    )
      return true;
    else return false;
  }
  getStaffPicsList() {
    this.commonService.getRecomandedCartProduct().subscribe((data) => {
      this.recommendedProductsList = data["data"];
    });
  }
}

interface User {
  userId: string;
  mobileVerified: string;
  firstName: string;
  lastName: string;
  documentVerify: string;
}

interface Token {
  token: string;
}

export interface Months {
  value: string;
  viewValue: string;
}

export interface Years {
  value: string;
  viewValue: string;
}

export interface IYear {
  text: string;
  value: string;
}
export interface IState {
  text: string;
  value: string;
}

export interface IPaymentModel {
  cardNumber: string;
  cardMonth: string;
  cardYear: string;
  state_address: string;
  cvv: string;
  /* zipCode:string; */
}

export interface IMonth {
  text: string;
  value: string;
}
